import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
  completeWith2hvdlbg1q1mlx as completeWith,
  withContext3ioifgw29h7cj as withContext,
  delay1f60wyf8ua1gc as delay,
  await24mygle6x7vn5 as await_0,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
import {
  startCoroutine1brije5juseye as startCoroutine,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instanceat14thlj150z as Unit_instance,
  printStackTrace18lnx7a39cni as printStackTrace,
  CancellationException3b36o9qz53rgr as CancellationException,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  VOID7hggqo3abtya as VOID,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_isFailure__impl__jpiriv2jp2gwqhnirp8 as _Result___get_isFailure__impl__jpiriv,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  lazy2hsh8ze7j6ikd as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  toLongw1zpgk99d84b as toLong,
  Long2qws0ah9gnpki as Long,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  endsWith3cq61xxngobwh as endsWith,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  KtList3hktaavzmj137 as KtList,
  toString1pkumu07cwy4m as toString,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  removeAll3o43e67jmwdpc as removeAll,
  sortWith4fnm6b3vw03s as sortWith,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  hashCodeq5arwsb9dgti as hashCode,
  compareValues1n2ayl87ihzfk as compareValues,
  to2cs3ny02qtbcb as to,
  startsWith26w8qjqapeeq6 as startsWith,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  until32cjhie5unyfs as until,
  toString30pk9tzaqopn as toString_0,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  Exceptiondt2hlxn7j7vw as Exception,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  Regexxgw0gjiagf4z as Regex,
  substringBefore3n7kj60w69hju as substringBefore,
  dropLastlqc2oyv04br0 as dropLast,
  split2bvyvnrlcifjv as split,
  getOrNull1go7ef9ldk0df as getOrNull,
  substringAfter1hku067gwr5ve as substringAfter,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  substringBeforekje8w2lxhyb6 as substringBefore_0,
  contains3ue2qo8xhmpf1 as contains,
  isBlank1dvkhjjvox3p0 as isBlank,
  substringBeforeLastqh7oeuvefdek as substringBeforeLast,
  trimStart1mkod6gyztuyy as trimStart,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  StringBuildermazzzhj6kkai as StringBuilder,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char19o2r8palgjof as Char,
  split3d3yeauc4rm2n as split_0,
  toMutableList20rdgwi7d3cwi as toMutableList,
  toString14fd7g605f91p as toString_1,
  joinToString1cxrrlmo0chqs as joinToString,
  KProperty1ca4yb4wlo496 as KProperty1,
  listOf1jh22dvmctj1r as listOf,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  captureStack1fzi4aczwc4hg as captureStack,
  createThis2j2avj17cvnv2 as createThis,
  toList383f556t1dixk as toList,
  equals2v6cggk171b6e as equals_0,
  first58ocm7j58k3q as first,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  toList3jhuyej2anx2q as toList_0,
  plus310ted5e4i90h as plus,
  Iterable1y3qizuf89iou as Iterable,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  Collection1k04j3hzsbod0 as Collection,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull_0,
  charArray2ujmm1qusno00 as charArray,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  println2shhhgwwt4c61 as println,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  emptyList1g2z5xcrvp2zy as emptyList,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  numberToLong1a4cndvg6c52s as numberToLong,
  newThrowablezl37abp36p5f as newThrowable,
  toInt5qdj874w69jh as toInt,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  isByteArray4nnzfn1x4o3w as isByteArray,
  drop258un2a8hqa2a as drop,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  lines3g90sq0zeq43v as lines,
  trimEnd17pt8cbotbalj as trimEnd_0,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  firstOrNull1982767dljvdy as firstOrNull,
  contains2el4s70rdq4ld as contains_0,
  arrayListOf1fz8nib0ncbow as arrayListOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instance1mbrm9vk5fsmd as Companion_instance_0,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance,
  unsupported198cz39rr1ztw as unsupported,
  MalformedInputException12cxjt7zq8psv as MalformedInputException,
  IOException33c9ezfvq1zr9 as IOException,
  jsObjectr1r5ao37ef4f as jsObject,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
  jsNewco39te1yl3up as jsNew,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_0,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  Proxy2ri7nr2ijtx4g as Proxy,
  VfsOpenMode_READ_getInstance1f4z3vmo4033h as VfsOpenMode_READ_getInstance,
  VfsCachedStatContext2gte5m09f8ox9 as VfsCachedStatContext,
  _PathInfo___init__impl__vpw96aee5jvc40cw94 as _PathInfo___init__impl__vpw96a,
  normalize34ppus0f5oo02 as normalize,
  get_baseName7iz3sifr1imo as get_baseName,
  get_parent1emraos91g459 as get_parent,
  _PathInfo___get_fullPath__impl__21fx6x1rfietgv3lnmb as _PathInfo___get_fullPath__impl__21fx6x,
  get_baseName2yf63efofm8te as get_baseName_0,
  get_pathInfo26tycr2r540oz as get_pathInfo,
  Companion_instance28oneptpyw0i3 as Companion_instance_1,
  UrlVfs292f1sja450ff as UrlVfs,
  Vfs3mgmizq3oi7gy as Vfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import {
  openAsync37anb1e84urmo as openAsync,
  toAsyncStream3ow20wz4trxzb as toAsyncStream,
  buffered29ldm4q6ez2xm as buffered,
  AsyncStreamBaseze8sfl15nwf0 as AsyncStreamBase,
  readAll1pkrq4jwoqns4 as readAll,
  asyncStreamWriter3ock1ljgyrdbd as asyncStreamWriter,
  readLine1dpyp1tbzc63w as readLine,
  readBytesExact305h8zdeltghk as readBytesExact,
  AsyncOutputStreamkoco1dsjo5gm as AsyncOutputStream,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { Companion_getInstance345a0ojzj45ct as Companion_getInstance_1 } from './korlibs-serialization-root-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  _Dyn___get_value__impl__bemnlg3oh7xeq0kw7zy as _Dyn___get_value__impl__bemnlg,
  _Dyn___get_keys__impl__o4xmor2sq7g1ji4zlvo as _Dyn___get_keys__impl__o4xmor,
  _Dyn___get_str__impl__dup4cs1orog9cldb3vj as _Dyn___get_str__impl__dup4cs,
  Dyn__get_impl_6l2p806edige75t7ys as Dyn__get_impl_6l2p80,
  Dyn__get_impl_6l2p802ap79h85reiiq as Dyn__get_impl_6l2p80_0,
  Dyn__toLongOrNull_impl_ws7y8j1thu5z85p5jvx as Dyn__toLongOrNull_impl_ws7y8j,
  _Dyn___get_list__impl__qpwjp3hmourv3nh1iz as _Dyn___get_list__impl__qpwjp,
  _Dyn___get_bool__impl__nv3iundhwx8dew4jjx as _Dyn___get_bool__impl__nv3iun,
  _Dyn___get_long__impl__wdxl7n14u0wvvaz9263 as _Dyn___get_long__impl__wdxl7n,
} from './korlibs-dyn-root-korlibs-dyn.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_2,
  _FastDuration___get_milliseconds__impl__ffr17unfwkaxi4cy42 as _FastDuration___get_milliseconds__impl__ffr17u,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  substringAfterOrNull6pqoc8ojvu1x as substringAfterOrNull,
  substringBeforeOrNullyyd9hl5du3pj as substringBeforeOrNull,
  toString2x583ovdqfjci as toString_2,
  get_UTF82geyfhi1l22xl as get_UTF8,
  INDENTS_getInstance3i2j33y4c5i8i as INDENTS_getInstance,
  substringEqualse7vi4930fev5 as substringEquals,
  toStringContext20qw1vqodfj0k as toStringContext,
  SimpleStrReader35udnj8g5ojo6 as SimpleStrReader,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  Companion_getInstance21eog9dvyf17t as Companion_getInstance_3,
  uncompressed1upyct1udgysk as uncompressed,
  get_Deflate2a0lyute7oxjd as get_Deflate,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { Companion_getInstancewos1kba8sml0 as Companion_getInstance_4 } from './korlibs-io-network-core-root-korlibs-io-network-core.mjs';
import { arraycopy3czrd9re36wzt as arraycopy } from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class _launch$slambda {
  constructor($callback) {
    this.g2x_1 = $callback;
  }
  u1n($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class launchUnscopedAndWait$1 {
  constructor($this_launchUnscopedAndWait, $deferred) {
    this.i2x_1 = $deferred;
    this.h2x_1 = $this_launchUnscopedAndWait;
  }
  kc() {
    return this.h2x_1;
  }
  mc(result) {
    completeWith(this.i2x_1, result);
  }
}
class launchUnscoped$1 {
  constructor($this_launchUnscoped) {
    this.j2x_1 = $this_launchUnscoped;
  }
  kc() {
    return this.j2x_1;
  }
  ol(result) {
    if (_Result___get_isFailure__impl__jpiriv(result)) {
      var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(result);
      if (tmp0_safe_receiver == null)
        null;
      else {
        printStackTrace(tmp0_safe_receiver);
      }
    }
  }
  mc(result) {
    return this.ol(result);
  }
}
class CatalogVfs$open$slambda {
  constructor(this$0, $path, $mode) {
    this.k2x_1 = this$0;
    this.l2x_1 = $path;
    this.m2x_1 = $mode;
  }
  u1n($this$withContext, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$withContext), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class CatalogVfs$open$2 extends AsyncStreamBase {
  static x2x(this$0, $base, $maxSize, $box) {
    if ($box === VOID)
      $box = {};
    $box.n2x_1 = this$0;
    $box.o2x_1 = $base;
    $box.p2x_1 = $maxSize;
    return this.u1r($box);
  }
  toString() {
    return 'CatalogVfs@' + this.n2x_1.r2x_1.toString() + ':' + toString(this.o2x_1);
  }
  n1r(position, buffer, offset, len, $completion) {
    // Inline function 'kotlin.comparisons.minOf' call
    var a = toLong(len);
    var b = this.p2x_1._v.v1(position);
    var rlen = (a.u1(b) <= 0 ? a : b).g2();
    return this.o2x_1.n1r(position, buffer, offset, rlen, $completion);
  }
  v1r(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  f1r($completion) {
    return this.p2x_1._v;
  }
  g1p($completion) {
    return this.o2x_1.g1p($completion);
  }
}
class CatalogVfs extends Proxy {
  constructor(parent) {
    super();
    this.r2x_1 = parent;
    this.s2x_1 = new Long(2097152, 0);
    this.t2x_1 = Companion_getInstance_0().ew('CatalogVfs');
    this.u2x_1 = LinkedHashMap.zb();
    this.v2x_1 = FastStringMap();
  }
  c23(path, range, $completion) {
    return super.c23(path, range, $completion);
  }
  b23(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea.bind(VOID, this, path, mode), $completion);
  }
  w22(path, $completion) {
    return this.r2x_1.yh(path);
  }
  d23(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc.bind(VOID, this, path), $completion);
  }
  w2x(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_statOrNull__vj5496.bind(VOID, this, path), $completion);
  }
  y2x(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_cachedListSimpleStatsOrNull__bbx84j.bind(VOID, this, path), $completion);
  }
  z2x(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_listSimpleStatsOrNull__lelcpx.bind(VOID, this, path), $completion);
  }
}
class StandardVfs {
  a2y() {
    throw NotImplementedError.md();
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.e2y_1 = function_0;
  }
  ri(a, b) {
    return this.e2y_1(a, b);
  }
  compare(a, b) {
    return this.ri(a, b);
  }
  h4() {
    return this.e2y_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class MountableVfs extends Proxy {
  constructor(closeMounts) {
    super();
    this.c2y_1 = closeMounts;
    this.d2y_1 = ArrayList.h1();
  }
  g1p($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_close__nh2uv0.bind(VOID, this), $completion);
  }
  f2y(folder, file) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfs.mount.<anonymous>' call
    unmountInternal(this, folder);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.d2y_1;
    var element = to(normalize(get_pathInfo(folder)), file);
    this_0.h(element);
    resort(this);
    return this;
  }
  w22(path, $completion) {
    var rpath = normalize(get_pathInfo(path));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.d2y_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.io.file.std.MountableVfs.access.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var destruct = this_0.d1(_unary__edvuaz);
      var base = destruct.dl();
      var file = destruct.el();
      if (startsWith(rpath, base)) {
        // Inline function 'kotlin.text.substring' call
        var startIndex = base.length;
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = rpath.substring(startIndex);
        return file.yh(tmp$ret$1);
      }
    }
    throw FileNotFoundException.ju(path);
  }
  toString() {
    return 'MountableVfs';
  }
}
class StandardPathsBase {}
function appPreferencesFolder(appId) {
  return Companion_getInstance().tt() ? '/Users/' + Companion_instance_0.yh('USER') + '/Library/Preferences/' + appId : Companion_getInstance().rt() ? '' + Companion_instance_0.yh('APPDATA') + '/' + appId : '' + Companion_instance_0.yh('HOME') + '/.config/' + appId;
}
class FinalUrlVfs$open$2 extends AsyncStreamBase {
  static o2z(this$0, $path, $mode, $fullUrl, $stat, $box) {
    if ($box === VOID)
      $box = {};
    $box.v2y_1 = this$0;
    $box.w2y_1 = $path;
    $box.x2y_1 = $mode;
    $box.y2y_1 = $fullUrl;
    $box.z2y_1 = $stat;
    return this.u1r($box);
  }
  toString() {
    return 'UrlVfs:' + this.v2y_1.x23_1 + ':' + this.w2y_1 + ':' + this.x2y_1.toString();
  }
  n1r(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  g1r($completion) {
    return this.z2y_1.a22_1.u1(new Long(0, 0)) >= 0;
  }
  f1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94.bind(VOID, this), $completion);
  }
}
class FinalUrlVfs extends UrlVfs {
  constructor(url, dummy, client, failFromStatus) {
    client = client === VOID ? createHttpClient() : client;
    failFromStatus = failFromStatus === VOID ? true : failFromStatus;
    super(url, dummy, failFromStatus);
    this.k2z_1 = dummy;
    this.l2z_1 = client;
    this.m2z_1 = url;
  }
  o22() {
    return this.m2z_1;
  }
  b23(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea_0.bind(VOID, this, path, mode), $completion);
  }
  c23(path, range, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readRange__lxd64t.bind(VOID, this, path, range), $completion);
  }
  d23(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_0.bind(VOID, this, path), $completion);
  }
  toString() {
    return 'UrlVfs';
  }
}
class Companion {
  constructor() {
    Companion_instance_2 = this;
    this.g30_1 = 0;
    this.h30_1 = Regex.lh('^([a-zA-Z0-9+.-]+)(?::([a-zA-Z]+))?:');
  }
  i30(scheme) {
    switch (scheme) {
      case 'ftp':
        return 21;
      case 'ftps':
        return 990;
      case 'http':
      case 'ws':
        return 80;
      case 'https':
      case 'wss':
        return 443;
      default:
        return -1;
    }
  }
  j30(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) {
    var tmp;
    if (scheme == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = scheme.toLowerCase();
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (subScheme == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_1 = subScheme.toLowerCase();
    }
    return new URL_0(opaque, tmp_0, tmp_1, userInfo, host, path, query, fragment, port);
  }
  k30(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port, $super) {
    scheme = scheme === VOID ? null : scheme;
    subScheme = subScheme === VOID ? null : subScheme;
    userInfo = userInfo === VOID ? null : userInfo;
    host = host === VOID ? null : host;
    path = path === VOID ? '' : path;
    query = query === VOID ? null : query;
    fragment = fragment === VOID ? null : fragment;
    opaque = opaque === VOID ? false : opaque;
    port = port === VOID ? this.g30_1 : port;
    return $super === VOID ? this.j30(scheme, subScheme, userInfo, host, path, query, fragment, opaque, port) : $super.j30.call(this, scheme, subScheme, userInfo, host, path, query, fragment, opaque, port);
  }
  ew(url) {
    var r = new StrReader(url);
    var schemeColon = r.q30(this.h30_1);
    var tmp;
    if (!(schemeColon == null)) {
      var isHierarchical = !(r.r30('//') == null);
      var nonScheme = r.s30();
      var schemeParts = split(dropLast(schemeColon, 1), [':']);
      var scheme = schemeParts.d1(0);
      var subScheme = getOrNull(schemeParts, 1);
      var nonFragment = substringBefore(nonScheme, _Char___init__impl__6a9atx(35));
      var fragment = substringAfterOrNull(nonScheme, _Char___init__impl__6a9atx(35));
      var nonQuery = substringBefore(nonFragment, _Char___init__impl__6a9atx(63));
      var query = substringAfterOrNull(nonFragment, _Char___init__impl__6a9atx(63));
      var authority = substringBefore(nonQuery, _Char___init__impl__6a9atx(47));
      var path = substringAfterOrNull(nonQuery, _Char___init__impl__6a9atx(47));
      var hostWithPort = substringAfter(authority, _Char___init__impl__6a9atx(64));
      var userInfo = substringBeforeOrNull(authority, _Char___init__impl__6a9atx(64));
      var host = substringBefore(hostWithPort, _Char___init__impl__6a9atx(58));
      var port = substringAfterOrNull(hostWithPort, _Char___init__impl__6a9atx(58));
      var tmp49_opaque = !isHierarchical;
      // Inline function 'kotlin.takeIf' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      // Inline function 'korlibs.io.net.Companion.invoke.<anonymous>' call
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(host) > 0) {
        tmp_0 = host;
      } else {
        tmp_0 = null;
      }
      var tmp50_host = tmp_0;
      var tmp51_path = !(path == null) ? '/' + path : '';
      var tmp0_elvis_lhs = port == null ? null : toIntOrNull(port);
      var tmp52_port = tmp0_elvis_lhs == null ? this.g30_1 : tmp0_elvis_lhs;
      tmp = this.j30(scheme, subScheme, userInfo, tmp50_host, tmp51_path, query, fragment, tmp49_opaque, tmp52_port);
    } else {
      var nonFragment_0 = substringBefore(url, _Char___init__impl__6a9atx(35));
      var fragment_0 = substringAfterOrNull(url, _Char___init__impl__6a9atx(35));
      var path_0 = substringBefore(nonFragment_0, _Char___init__impl__6a9atx(63));
      var query_0 = substringAfterOrNull(nonFragment_0, _Char___init__impl__6a9atx(63));
      tmp = this.k30(null, null, null, null, path_0, query_0, fragment_0, false);
    }
    return tmp;
  }
  t30(url) {
    return !((new StrReader(url)).q30(this.h30_1) == null);
  }
  u30(base, access) {
    var refinedAccess = startsWith(access, '//') && contains(base, ':') ? substringBefore_0(base, ':') + ':' + access : access;
    if (this.t30(refinedAccess))
      return refinedAccess;
    if (isBlank(base)) {
      throw MalformedInputException.fs('The base URL should not be empty, or the access URL must be absolute.');
    }
    if (!this.t30(base)) {
      throw MalformedInputException.fs('At least one of the base URL or access URL must be absolute.');
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(refinedAccess) === 0) {
      tmp = base;
    } else {
      if (startsWith(refinedAccess, '/')) {
        tmp = Companion_getInstance_5().ew(base).t2y(VOID, VOID, VOID, VOID, VOID, normalizeUrl(refinedAccess), null).u2y();
      } else {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.io.net.Companion.resolve.<anonymous>' call
        var $this$run = Companion_getInstance_5().ew(base);
        var tmp_0;
        if (startsWith(refinedAccess, '?') || startsWith(refinedAccess, '#')) {
          tmp_0 = $this$run.m2y_1 + refinedAccess;
        } else {
          tmp_0 = substringBeforeLast($this$run.m2y_1, _Char___init__impl__6a9atx(47)) + '/' + refinedAccess;
        }
        var refinedPath = tmp_0;
        tmp = $this$run.t2y(VOID, VOID, VOID, VOID, VOID, '/' + trimStart(normalizeUrl(refinedPath), charArrayOf([_Char___init__impl__6a9atx(47)])), null).u2y();
      }
    }
    return tmp;
  }
}
class URL_0 {
  constructor(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    Companion_getInstance_5();
    this.h2y_1 = isOpaque;
    this.i2y_1 = scheme;
    this.j2y_1 = subScheme;
    this.k2y_1 = userInfo;
    this.l2y_1 = host;
    this.m2y_1 = path;
    this.n2y_1 = query;
    this.o2y_1 = fragment;
    this.p2y_1 = defaultPort;
    var tmp = this;
    tmp.q2y_1 = lazy(URL$fullUrl$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.r2y_1 = lazy(URL$fullUrlWithoutScheme$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.s2y_1 = lazy(URL$pathWithQuery$delegate$lambda(this));
  }
  w30() {
    return this.i2y_1 === 'https' || this.i2y_1 === 'wss' || this.i2y_1 === 'ftps';
  }
  x30() {
    return Companion_getInstance_5().i30(this.i2y_1);
  }
  y30() {
    return this.p2y_1 === Companion_getInstance_5().g30_1 ? this.x30() : this.p2y_1;
  }
  u2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q2y_1;
    fullUrl$factory();
    return this_0.p1();
  }
  z30(includeScheme, out) {
    if (includeScheme && !(this.i2y_1 == null)) {
      out.mb('' + this.i2y_1 + ':');
      if (!(this.j2y_1 == null)) {
        out.mb('' + this.j2y_1 + ':');
      }
      if (!this.h2y_1) {
        out.mb('//');
      }
    }
    if (!(this.k2y_1 == null)) {
      out.mb('' + this.k2y_1 + '@');
    }
    if (!(this.l2y_1 == null)) {
      out.mb(this.l2y_1);
    }
    if (!(this.y30() === Companion_getInstance_5().g30_1) && !(this.y30() === this.x30())) {
      out.nb(_Char___init__impl__6a9atx(58)).pg(this.y30());
    }
    out.mb(this.m2y_1);
    if (!(this.n2y_1 == null)) {
      out.mb('?' + this.n2y_1);
    }
    if (!(this.o2y_1 == null)) {
      out.mb('#' + this.o2y_1);
    }
    return out;
  }
  v30(includeScheme, out, $super) {
    includeScheme = includeScheme === VOID ? true : includeScheme;
    out = out === VOID ? StringBuilder.f() : out;
    return $super === VOID ? this.z30(includeScheme, out) : $super.z30.call(this, includeScheme, out);
  }
  toString() {
    return this.u2y();
  }
  a31(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) {
    return new URL_0(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  t2y(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort, $super) {
    isOpaque = isOpaque === VOID ? this.h2y_1 : isOpaque;
    scheme = scheme === VOID ? this.i2y_1 : scheme;
    subScheme = subScheme === VOID ? this.j2y_1 : subScheme;
    userInfo = userInfo === VOID ? this.k2y_1 : userInfo;
    host = host === VOID ? this.l2y_1 : host;
    path = path === VOID ? this.m2y_1 : path;
    query = query === VOID ? this.n2y_1 : query;
    fragment = fragment === VOID ? this.o2y_1 : fragment;
    defaultPort = defaultPort === VOID ? this.p2y_1 : defaultPort;
    return $super === VOID ? this.a31(isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort) : $super.a31.call(this, isOpaque, scheme, subScheme, userInfo, host, path, query, fragment, defaultPort);
  }
  hashCode() {
    var result = getBooleanHashCode(this.h2y_1);
    result = imul(result, 31) + (this.i2y_1 == null ? 0 : getStringHashCode(this.i2y_1)) | 0;
    result = imul(result, 31) + (this.j2y_1 == null ? 0 : getStringHashCode(this.j2y_1)) | 0;
    result = imul(result, 31) + (this.k2y_1 == null ? 0 : getStringHashCode(this.k2y_1)) | 0;
    result = imul(result, 31) + (this.l2y_1 == null ? 0 : getStringHashCode(this.l2y_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2y_1) | 0;
    result = imul(result, 31) + (this.n2y_1 == null ? 0 : getStringHashCode(this.n2y_1)) | 0;
    result = imul(result, 31) + (this.o2y_1 == null ? 0 : getStringHashCode(this.o2y_1)) | 0;
    result = imul(result, 31) + this.p2y_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof URL_0))
      return false;
    var tmp0_other_with_cast = other instanceof URL_0 ? other : THROW_CCE();
    if (!(this.h2y_1 === tmp0_other_with_cast.h2y_1))
      return false;
    if (!(this.i2y_1 == tmp0_other_with_cast.i2y_1))
      return false;
    if (!(this.j2y_1 == tmp0_other_with_cast.j2y_1))
      return false;
    if (!(this.k2y_1 == tmp0_other_with_cast.k2y_1))
      return false;
    if (!(this.l2y_1 == tmp0_other_with_cast.l2y_1))
      return false;
    if (!(this.m2y_1 === tmp0_other_with_cast.m2y_1))
      return false;
    if (!(this.n2y_1 == tmp0_other_with_cast.n2y_1))
      return false;
    if (!(this.o2y_1 == tmp0_other_with_cast.o2y_1))
      return false;
    if (!(this.p2y_1 === tmp0_other_with_cast.p2y_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_3 = this;
    this.p2z_1 = Methods_OPTIONS_getInstance();
    this.q2z_1 = Methods_GET_getInstance();
    this.r2z_1 = Methods_HEAD_getInstance();
    this.s2z_1 = Methods_POST_getInstance();
    this.t2z_1 = Methods_PUT_getInstance();
    this.u2z_1 = Methods_DELETE_getInstance();
    this.v2z_1 = Methods_TRACE_getInstance();
    this.w2z_1 = Methods_CONNECT_getInstance();
    this.x2z_1 = Methods_PATCH_getInstance();
    this.y2z_1 = listOf([this.p2z_1, this.q2z_1, this.r2z_1, this.s2z_1, this.t2z_1, this.u2z_1, this.v2z_1, this.w2z_1, this.x2z_1]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.y2z_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Companion.valuesMap.<anonymous>' call
      var tmp$ret$0 = to(item.k3_1, item);
      destination.h(tmp$ret$0);
    }
    tmp.z2z_1 = toMap(destination);
  }
}
class Companion_1 {}
class Companion_2 {
  constructor() {
    this.e30_1 = 'Content-Length';
    this.f30_1 = 'Content-Type';
  }
}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.b31_1 = function_0;
  }
  ri(a, b) {
    return this.b31_1(a, b);
  }
  compare(a, b) {
    return this.ri(a, b);
  }
  h4() {
    return this.b31_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.h4(), other.h4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.h4());
  }
}
class Methods extends Enum {}
class HttpException extends IOException {
  static j31(statusCode, msg, statusText, headers) {
    msg = msg === VOID ? 'Error' + statusCode : msg;
    var tmp;
    if (statusText === VOID) {
      var tmp0_elvis_lhs = HttpStatusMessage_getInstance().k31_1.a3(statusCode);
      tmp = tmp0_elvis_lhs == null ? 'Error' + statusCode : tmp0_elvis_lhs;
    } else {
      tmp = statusText;
    }
    statusText = tmp;
    headers = headers === VOID ? Headers.l31([]) : headers;
    var $this = this.mu('' + statusCode + ' ' + statusText + ' - ' + msg);
    captureStack($this, $this.i31_1);
    $this.e31_1 = statusCode;
    $this.f31_1 = msg;
    $this.g31_1 = statusText;
    $this.h31_1 = headers;
    return $this;
  }
}
class Headers {
  static m31(items) {
    var $this = createThis(this);
    $this.a30_1 = items;
    return $this;
  }
  static l31(items) {
    return this.m31(toList(items));
  }
  static b30(map) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(map.e1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = map.n1().a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.<init>.<anonymous>' call
      var tmp$ret$1 = to(item.o1(), item.p1());
      destination.h(tmp$ret$1);
    }
    return this.m31(destination);
  }
  a1() {
    return this.a30_1.a1();
  }
  yh(key) {
    return this.n31(key);
  }
  n31(key) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.a30_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.io.net.http.Headers.getFirst.<anonymous>' call
        if (equals_0(element.bl_1, key, true)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp56_safe_receiver = tmp$ret$1;
    return tmp56_safe_receiver == null ? null : tmp56_safe_receiver.cl_1;
  }
  o31() {
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.groupBy' call
    // Inline function 'kotlin.collections.groupByTo' call
    var this_0 = this.a30_1;
    var destination = LinkedHashMap.zb();
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var key = element.bl_1.toLowerCase();
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.a3(key);
      var tmp;
      if (value == null) {
        // Inline function 'kotlin.collections.groupByTo.<anonymous>' call
        var answer = ArrayList.h1();
        destination.c3(key, answer);
        tmp = answer;
      } else {
        tmp = value;
      }
      var list = tmp;
      list.h(element);
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(destination.e1());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = destination.n1().a1();
    while (tmp0_iterator_0.b1()) {
      var item = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
      var tmp_0 = first(item.p1()).bl_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = item.p1();
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_1 = this_1.a1();
      while (tmp0_iterator_1.b1()) {
        var item_0 = tmp0_iterator_1.c1();
        // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>.<anonymous>' call
        var tmp$ret$8 = item_0.cl_1;
        destination_1.h(tmp$ret$8);
      }
      var tmp$ret$11 = to(tmp_0, destination_1);
      destination_0.h(tmp$ret$11);
    }
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Http$Headers$toListGrouped$lambda;
    var tmp$ret$14 = new sam$kotlin_Comparator$0_0(tmp_1);
    return sortedWith(destination_0, tmp$ret$14);
  }
  p31(newHeaders) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(newHeaders, 10));
    var tmp0_iterator = newHeaders.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = item.bl_1.toLowerCase();
      destination.h(tmp$ret$2);
    }
    var replaceKeys = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.a30_1;
    var destination_0 = ArrayList.h1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.net.http.Headers.withReplaceHeaders.<anonymous>' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = element.bl_1.toLowerCase();
      if (!replaceKeys.u2(tmp$ret$6)) {
        destination_0.h(element);
      }
    }
    return Headers.m31(plus(destination_0, toList_0(newHeaders)));
  }
  q31(newHeaders) {
    return this.p31(toList(newHeaders));
  }
  r31(newHeaders) {
    return this.p31(toList_0(newHeaders));
  }
  toString() {
    return 'Headers(' + joinToString(this.o31(), ', ') + ')';
  }
  hashCode() {
    return hashCode(this.a30_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Headers))
      return false;
    var tmp0_other_with_cast = other instanceof Headers ? other : THROW_CCE();
    if (!equals(this.a30_1, tmp0_other_with_cast.a30_1))
      return false;
    return true;
  }
}
class Companion_3 {
  s31(status, statusText, headers, rawContent, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, status, statusText, headers, rawContent), $completion);
  }
}
class Companion_4 {
  constructor() {
    Companion_instance_7 = this;
    this.v31_1 = new RequestConfig();
  }
}
class Response {
  constructor(status, statusText, headers, rawContent, content) {
    this.a2z_1 = status;
    this.b2z_1 = statusText;
    this.c2z_1 = headers;
    this.d2z_1 = rawContent;
    this.e2z_1 = content;
    this.f2z_1 = this.a2z_1 < 400;
    var tmp = this;
    tmp.g2z_1 = lazy(HttpClient$Response$responseCharset$delegate$lambda);
  }
  t31($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readAllBytes__ja4yyw.bind(VOID, this), $completion);
  }
  w31() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g2z_1;
    responseCharset$factory();
    return this_0.p1();
  }
  x31(charset, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readAllString__7ikxrc.bind(VOID, this, charset), $completion);
  }
  u31(charset, $completion, $super) {
    charset = charset === VOID ? this.w31() : charset;
    return $super === VOID ? this.x31(charset, $completion) : $super.x31.call(this, charset, $completion);
  }
  d30($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_checkErrors__u7iznj.bind(VOID, this), $completion);
  }
  y31(content) {
    return new CompletedResponse(this.a2z_1, this.b2z_1, this.c2z_1, content);
  }
  toString() {
    return 'Response(status=' + this.a2z_1 + ', statusText=' + this.b2z_1 + ', headers=' + this.c2z_1.toString() + ', rawContent=' + toString(this.d2z_1) + ', content=' + toString(this.e2z_1) + ')';
  }
  hashCode() {
    var result = this.a2z_1;
    result = imul(result, 31) + getStringHashCode(this.b2z_1) | 0;
    result = imul(result, 31) + this.c2z_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d2z_1) | 0;
    result = imul(result, 31) + hashCode(this.e2z_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Response))
      return false;
    var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
    if (!(this.a2z_1 === tmp0_other_with_cast.a2z_1))
      return false;
    if (!(this.b2z_1 === tmp0_other_with_cast.b2z_1))
      return false;
    if (!this.c2z_1.equals(tmp0_other_with_cast.c2z_1))
      return false;
    if (!equals(this.d2z_1, tmp0_other_with_cast.d2z_1))
      return false;
    if (!equals(this.e2z_1, tmp0_other_with_cast.e2z_1))
      return false;
    return true;
  }
}
class CompletedResponse {
  constructor(status, statusText, headers, content) {
    this.z31_1 = status;
    this.a32_1 = statusText;
    this.b32_1 = headers;
    this.c32_1 = content;
    this.d32_1 = this.z31_1 < 400;
  }
  toString() {
    return 'CompletedResponse(status=' + this.z31_1 + ', statusText=' + this.a32_1 + ', headers=' + this.b32_1.toString() + ', content=' + toString_0(this.c32_1) + ')';
  }
  hashCode() {
    var result = this.z31_1;
    result = imul(result, 31) + getStringHashCode(this.a32_1) | 0;
    result = imul(result, 31) + this.b32_1.hashCode() | 0;
    result = imul(result, 31) + (this.c32_1 == null ? 0 : hashCode(this.c32_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CompletedResponse ? other : THROW_CCE();
    if (!(this.z31_1 === tmp0_other_with_cast.z31_1))
      return false;
    if (!(this.a32_1 === tmp0_other_with_cast.a32_1))
      return false;
    if (!this.b32_1.equals(tmp0_other_with_cast.b32_1))
      return false;
    if (!equals(this.c32_1, tmp0_other_with_cast.c32_1))
      return false;
    return true;
  }
}
class RequestConfig {
  constructor(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    Companion_getInstance_10();
    followRedirects = followRedirects === VOID ? true : followRedirects;
    throwErrors = throwErrors === VOID ? false : throwErrors;
    maxRedirects = maxRedirects === VOID ? 10 : maxRedirects;
    referer = referer === VOID ? null : referer;
    simulateBrowser = simulateBrowser === VOID ? false : simulateBrowser;
    this.e32_1 = followRedirects;
    this.f32_1 = throwErrors;
    this.g32_1 = maxRedirects;
    this.h32_1 = referer;
    this.i32_1 = simulateBrowser;
  }
  j32(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) {
    return new RequestConfig(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  k32(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser, $super) {
    followRedirects = followRedirects === VOID ? this.e32_1 : followRedirects;
    throwErrors = throwErrors === VOID ? this.f32_1 : throwErrors;
    maxRedirects = maxRedirects === VOID ? this.g32_1 : maxRedirects;
    referer = referer === VOID ? this.h32_1 : referer;
    simulateBrowser = simulateBrowser === VOID ? this.i32_1 : simulateBrowser;
    return $super === VOID ? this.j32(followRedirects, throwErrors, maxRedirects, referer, simulateBrowser) : $super.j32.call(this, followRedirects, throwErrors, maxRedirects, referer, simulateBrowser);
  }
  toString() {
    return 'RequestConfig(followRedirects=' + this.e32_1 + ', throwErrors=' + this.f32_1 + ', maxRedirects=' + this.g32_1 + ', referer=' + this.h32_1 + ', simulateBrowser=' + this.i32_1 + ')';
  }
  hashCode() {
    var result = getBooleanHashCode(this.e32_1);
    result = imul(result, 31) + getBooleanHashCode(this.f32_1) | 0;
    result = imul(result, 31) + this.g32_1 | 0;
    result = imul(result, 31) + (this.h32_1 == null ? 0 : getStringHashCode(this.h32_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i32_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RequestConfig))
      return false;
    var tmp0_other_with_cast = other instanceof RequestConfig ? other : THROW_CCE();
    if (!(this.e32_1 === tmp0_other_with_cast.e32_1))
      return false;
    if (!(this.f32_1 === tmp0_other_with_cast.f32_1))
      return false;
    if (!(this.g32_1 === tmp0_other_with_cast.g32_1))
      return false;
    if (!(this.h32_1 == tmp0_other_with_cast.h32_1))
      return false;
    if (!(this.i32_1 === tmp0_other_with_cast.i32_1))
      return false;
    return true;
  }
}
class HttpClient {}
function request(method, url, headers, content, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_request__hjt9xh.bind(VOID, this, method, url, headers, content, config), $completion);
}
function request$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.l31([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? Companion_getInstance_10().v31_1 : config;
  return $super === VOID ? this.t32(method, url, headers, content, config, $completion) : request(method, url, headers, content, config, $completion);
}
function requestAsBytes(method, url, headers, content, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_requestAsBytes__v4smbm.bind(VOID, this, method, url, headers, content, config), $completion);
}
function requestAsBytes$default(method, url, headers, content, config, $completion, $super) {
  headers = headers === VOID ? Headers.l31([]) : headers;
  content = content === VOID ? null : content;
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.v32(method, url, headers, content, config, $completion) : requestAsBytes(method, url, headers, content, config, $completion);
}
function readBytes(url, config, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBytes__epy2u7.bind(VOID, this, url, config), $completion);
}
function readBytes$default(url, config, $completion, $super) {
  config = config === VOID ? new RequestConfig() : config;
  return $super === VOID ? this.w32(url, config, $completion) : readBytes(url, config, $completion);
}
class Companion_5 {
  constructor() {
    Companion_instance_8 = this;
    this.l32_1 = createHttpClientFromFetch$accessor$8g8dwi();
    this.m32_1 = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36';
    this.n32_1 = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8';
    this.o32_1 = 'en-us';
    this.p32_1 = 'gzip, deflate';
    this.q32_1 = 'Close';
  }
  s32(method, url, headers, content, $completion) {
    return this.l32_1.s32(method, url, headers, content, $completion);
  }
  t32(method, url, headers, content, config, $completion) {
    return this.l32_1.t32(method, url, headers, content, config, $completion);
  }
  v32(method, url, headers, content, config, $completion) {
    return this.l32_1.v32(method, url, headers, content, config, $completion);
  }
  w32(url, config, $completion) {
    return this.l32_1.w32(url, config, $completion);
  }
  r32(headers, host) {
    var out = Headers.l31([to('User-Agent', this.m32_1), to('Accept', this.n32_1), to('Accept-Language', this.o32_1), to('Accept-Encoding', this.p32_1), to('Connection', this.q32_1)]).r31(headers);
    return !(host == null) ? out.q31([to('Host', host)]) : out;
  }
}
class HttpStatusMessage {
  constructor() {
    HttpStatusMessage_instance = this;
    this.k31_1 = linkedMapOf([to(100, 'Continue'), to(101, 'Switching Protocols'), to(200, 'OK'), to(201, 'Created'), to(202, 'Accepted'), to(203, 'Non-Authoritative Information'), to(204, 'No Content'), to(205, 'Reset Content'), to(206, 'Partial Content'), to(300, 'Multiple Choices'), to(301, 'Moved Permanently'), to(302, 'Found'), to(303, 'See Other'), to(304, 'Not Modified'), to(305, 'Use Proxy'), to(307, 'Temporary Redirect'), to(400, 'Bad Request'), to(401, 'Unauthorized'), to(402, 'Payment Required'), to(403, 'Forbidden'), to(404, 'Not Found'), to(405, 'Method Not Allowed'), to(406, 'Not Acceptable'), to(407, 'Proxy Authentication Required'), to(408, 'Request Timeout'), to(409, 'Conflict'), to(410, 'Gone'), to(411, 'Length Required'), to(412, 'Precondition Failed'), to(413, 'Request Entity Too Large'), to(414, 'Request-URI Too Long'), to(415, 'Unsupported Media Type'), to(416, 'Requested Range Not Satisfiable'), to(417, 'Expectation Failed'), to(418, "I'm a teapot"), to(422, 'Unprocessable Entity (WebDAV - RFC 4918)'), to(423, 'Locked (WebDAV - RFC 4918)'), to(424, 'Failed Dependency (WebDAV) (RFC 4918)'), to(425, 'Unassigned'), to(426, 'Upgrade Required (RFC 7231)'), to(428, 'Precondition Required'), to(429, 'Too Many Requests'), to(431, 'Request Header Fileds Too Large)'), to(449, 'Error449'), to(451, 'Unavailable for Legal Reasons'), to(500, 'Internal Server Error'), to(501, 'Not Implemented'), to(502, 'Bad Gateway'), to(503, 'Service Unavailable'), to(504, 'Gateway Timeout'), to(505, 'HTTP Version Not Supported'), to(506, 'Variant Also Negotiates (RFC 2295)'), to(507, 'Insufficient Storage (WebDAV - RFC 4918)'), to(508, 'Loop Detected (WebDAV)'), to(509, 'Bandwidth Limit Exceeded'), to(510, 'Not Extended (RFC 2774)'), to(511, 'Network Authentication Required')]);
  }
}
class ProxiedHttpFactory {
  constructor(parent) {
    this.y32_1 = parent;
    this.z32_1 = parent;
  }
  x32() {
    return this.y32_1.x32();
  }
}
class withTransferEncoding$slambda {
  constructor($input) {
    this.a33_1 = $input;
  }
  l20(out, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, out), $completion);
  }
  od(p1, $completion) {
    return this.l20((!(p1 == null) ? isInterface(p1, AsyncOutputStream) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class createHttpClientFromFetch$1 {
  constructor($fetch) {
    this.c33_1 = $fetch;
    this.b33_1 = false;
  }
  s32(method, url, headers, content, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_requestInternal__facax4.bind(VOID, this, method, url, headers, content), $completion);
  }
}
class Resources {
  constructor(coroutineContext, root, parent) {
    root = root === VOID ? get_resourcesVfs() : root;
    parent = parent === VOID ? null : parent;
    this.d33_1 = coroutineContext;
    this.e33_1 = root;
    this.f33_1 = parent;
    this.g33_1 = LinkedHashMap.zb();
  }
}
class Text {}
class Marker {}
class Line {
  constructor(str) {
    this.i33_1 = str;
  }
  h33() {
    return this.i33_1;
  }
  toString() {
    return 'Line(str=' + this.i33_1 + ')';
  }
  hashCode() {
    return getStringHashCode(this.i33_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line))
      return false;
    var tmp0_other_with_cast = other instanceof Line ? other : THROW_CCE();
    if (!(this.i33_1 === tmp0_other_with_cast.i33_1))
      return false;
    return true;
  }
}
class LineDeferred {}
class EmptyLineOnce {}
class Indent {}
class Unindent {}
class INDENTS {
  d1(index) {
    return INDENTS_getInstance().d1(index);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'korlibs.io.util.Companion.gen' call
    Companion_getInstance_12();
    var indenter = new Indenter();
    // Inline function 'korlibs.io.util.Companion.EMPTY.<anonymous>' call
    tmp.j33_1 = indenter;
  }
  k33(init) {
    // Inline function 'korlibs.io.util.Companion.gen' call
    var indenter = new Indenter();
    init(indenter);
    return indenter;
  }
}
class IndenterEvaluator {
  constructor(markHandler, indentEmptyLines, doIndent) {
    this.l33_1 = markHandler;
    this.m33_1 = indentEmptyLines;
    this.n33_1 = doIndent;
    this.o33_1 = StringBuilder.f();
    this.p33_1 = 0;
    this.q33_1 = true;
    this.r33_1 = 0;
    this.s33_1 = false;
  }
  t33(str) {
    return this.o33_1.mb(str);
  }
  u33(str) {
    return this.o33_1.nb(str);
  }
  v33() {
    if (this.n33_1) {
      this.u33(_Char___init__impl__6a9atx(10));
    }
    this.p33_1 = this.p33_1 + 1 | 0;
    this.q33_1 = true;
  }
  w33(actions) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < actions.e1()) {
      // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var action = actions.d1(_unary__edvuaz);
      if (isInterface(action, Text)) {
        if (this.q33_1) {
          var tmp;
          if (!this.m33_1) {
            // Inline function 'kotlin.text.isEmpty' call
            var this_0 = action.h33();
            tmp = charSequenceLength(this_0) === 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            this.v33();
          } else {
            if (this.n33_1)
              this.t33(INDENTS_instance.d1(this.r33_1));
            else
              this.t33(' ');
          }
        }
        this.t33(action.h33());
        if (action instanceof Line) {
          var tmp_0 = this;
          var tmp_1 = this.p33_1;
          // Inline function 'kotlin.text.count' call
          var count = 0;
          var indexedObject = action.i33_1;
          var inductionVariable = 0;
          while (inductionVariable < charSequenceLength(indexedObject)) {
            var element = charSequenceGet(indexedObject, inductionVariable);
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.io.util.IndenterEvaluator.eval.<anonymous>.<anonymous>' call
            if (element === _Char___init__impl__6a9atx(10)) {
              count = count + 1 | 0;
            }
          }
          tmp_0.p33_1 = tmp_1 + count | 0;
          this.v33();
        } else {
          this.q33_1 = false;
        }
        this.s33_1 = true;
      } else {
        if (action instanceof LineDeferred) {
          this.w33(action.b34_1().y33_1);
        } else {
          if (equals(action, Indent_instance) || equals(action, Unindent_instance)) {
            this.s33_1 = false;
            this.r33_1 = this.r33_1 + (equals(action, Indent_instance) ? 1 : -1) | 0;
          } else {
            if (equals(action, EmptyLineOnce_instance)) {
              if (this.s33_1) {
                this.v33();
                this.s33_1 = false;
              }
            } else {
              if (action instanceof Marker) {
                var tmp104_safe_receiver = this.l33_1;
                if (tmp104_safe_receiver == null)
                  null;
                else
                  tmp104_safe_receiver(this.o33_1, this.p33_1, action.x33_1);
              }
            }
          }
        }
      }
    }
  }
}
class Indenter {
  constructor(actions) {
    Companion_getInstance_12();
    var tmp;
    if (actions === VOID) {
      // Inline function 'kotlin.collections.arrayListOf' call
      tmp = ArrayList.h1();
    } else {
      tmp = actions;
    }
    actions = tmp;
    this.y33_1 = actions;
    this.z33_1 = true;
    this.a34_1 = '';
  }
  c34(indenter) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.y33_1.f1(indenter.y33_1);
    return this;
  }
  d34(str) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.line.<anonymous>' call
    this.y33_1.h(new Line(str));
    return this;
  }
  e34() {
    this.y33_1.h(Indent_instance);
  }
  f34() {
    this.y33_1.h(Unindent_instance);
  }
  g34(markHandler, doIndent) {
    // Inline function 'kotlin.apply' call
    var this_0 = new IndenterEvaluator(markHandler, this.z33_1, doIndent);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.Indenter.toString.<anonymous>' call
    this_0.w33(this.y33_1);
    return this_0.o33_1.toString();
  }
  toString() {
    return this.g34(null, true);
  }
}
class Once {
  constructor() {
    this.h34_1 = false;
  }
}
class Companion_7 {}
class BaseStrReader {
  uv() {
    return !this.tv();
  }
  jw() {
    return this.k34(0);
  }
  kw() {
    var out = this.jw();
    this.b14(1);
    return out;
  }
  r30(lit, consume, $super) {
    consume = consume === VOID ? true : consume;
    return $super === VOID ? this.j34(lit, consume) : $super.j34.call(this, lit, consume);
  }
  i34(count) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.d14(count);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.util.BaseStrReader.read.<anonymous>' call
    this.b14(count);
    return this_0;
  }
}
class StrReader extends BaseStrReader {
  constructor(str, file, pos) {
    file = file === VOID ? 'file' : file;
    pos = pos === VOID ? 0 : pos;
    super();
    this.l30_1 = str;
    this.m30_1 = file;
    this.n30_1 = pos;
    this.o30_1 = charArray(this.l30_1.length);
    this.p30_1 = this.l30_1.length;
  }
  lw() {
    return this.n30_1;
  }
  ov() {
    return this.p30_1 - this.n30_1 | 0;
  }
  tv() {
    return this.n30_1 >= this.l30_1.length;
  }
  d14(count) {
    return substr(this, this.n30_1, count);
  }
  jw() {
    return this.uv() ? charSequenceGet(this.l30_1, this.n30_1) : _Char___init__impl__6a9atx(0);
  }
  kw() {
    return this.uv() ? charSequenceGet(this.l30_1, posSkip(this, 1)) : _Char___init__impl__6a9atx(0);
  }
  s30() {
    return this.i34(this.ov());
  }
  b14(count) {
    this.n30_1 = this.n30_1 + count | 0;
    return this;
  }
  j34(lit, consume) {
    if (!substringEquals(StringCompanionObject_instance, this.l30_1, this.n30_1, lit, 0, lit.length))
      return null;
    if (consume)
      this.n30_1 = this.n30_1 + lit.length | 0;
    return lit;
  }
  q30(v) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.l30_1;
    var startIndex = this.n30_1;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this_0.substring(startIndex);
    var tmp0_elvis_lhs = v.nh(tmp$ret$1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var result = tmp;
    var m = ensureNotNull(result.xh().d1(0)).wh_1;
    this.n30_1 = this.n30_1 + m.length | 0;
    return m;
  }
  k34(offset) {
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = this.l30_1;
    var index = this.n30_1 + offset | 0;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, index);
    } else {
      // Inline function 'korlibs.io.util.StrReader.peekOffset.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    return tmp;
  }
}
class DemoWorkerTask$execute$slambda {
  l34(params, $completion) {
    println('TEST!!!!! ' + toString(params));
    return 11;
  }
  od(p1, $completion) {
    return this.l34((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class WorkerTask {
  constructor() {
    this.s34_1 = null;
    this.t34_1 = false;
    var tmp = this;
    // Inline function 'kotlin.collections.listOf' call
    tmp.u34_1 = emptyList();
    this.v34_1 = null;
    this.w34_1 = false;
  }
  y34(_set____db54di) {
    this.u34_1 = _set____db54di;
  }
  z34() {
    if (!this.w34_1) {
      // Inline function 'kotlin.error' call
      var message = 'Must wrap function around runSuspend';
      throw IllegalStateException.t4(toString(message));
    }
    return this.u34_1;
  }
  a35(_set____db54di) {
    this.v34_1 = _set____db54di;
  }
  b35() {
    return this.v34_1;
  }
  x34(block) {
    this.w34_1 = true;
    try {
      if (this.t34_1) {
        this.s34_1 = currentStackTrace();
        return Unit_instance;
      }
      var deferred = CompletableDeferred();
      var tmp = EmptyCoroutineContext_getInstance();
      launchImmediately(tmp, WorkerTask$runSuspend$slambda_0(deferred, this, block));
      this.v34_1 = deferred;
    }finally {
      this.w34_1 = false;
    }
  }
  r34() {
    return Unit_instance;
  }
  c35() {
    this.t34_1 = true;
    try {
      this.r34();
      return ensureNotNull(this.s34_1);
    }finally {
      this.t34_1 = false;
    }
  }
}
class DemoWorkerTask extends WorkerTask {
  r34() {
    return this.x34(DemoWorkerTask$execute$slambda_0());
  }
}
class WorkerTask$runSuspend$slambda {
  constructor($deferred, this$0, $block) {
    this.d35_1 = $deferred;
    this.e35_1 = this$0;
    this.f35_1 = $block;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
  }
}
class _WorkerImpl {
  g35() {
    return Unit_instance;
  }
  h35() {
    return false;
  }
}
class Companion_8 {}
class BlobAsyncBaseStream extends AsyncStreamBase {
  static j35(blob) {
    var $this = this.u1r();
    $this.i35_1 = blob;
    return $this;
  }
  g1p($completion) {
  }
  n1r(position, buffer, offset, len, $completion) {
    var deferred = CompletableDeferred();
    var reader = new FileReader();
    reader.onload = BlobAsyncBaseStream$read$lambda(reader, len, buffer, offset, deferred);
    reader.onerror = BlobAsyncBaseStream$read$lambda_0(deferred, reader);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.i35_1;
    reader.readAsArrayBuffer(tmp$ret$1.slice(position.g4(), position.g4() + len));
    return deferred.h17($completion);
  }
  f1r($completion) {
    return numberToLong(this.i35_1.size);
  }
}
class toVfs$1 extends Vfs {
  constructor($file, $box) {
    if ($box === VOID)
      $box = {};
    $box.l35_1 = $file;
    super($box);
    this.k35_1 = $file.name;
  }
  o22() {
    return this.k35_1;
  }
  b23(path, mode, $completion) {
    return openAsync_0(this.l35_1);
  }
}
class standardVfs$1 extends StandardVfs {
  constructor() {
    super();
    var tmp = this;
    tmp.p35_1 = lazy(standardVfs$o$resourcesVfs$delegate$lambda);
    var tmp_0 = this;
    tmp_0.q35_1 = lazy(standardVfs$o$rootLocalVfs$delegate$lambda);
  }
  a2y() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p35_1;
    resourcesVfs$factory();
    return this_0.p1();
  }
}
class StandardPaths {}
class httpFactory$2$1 {
  x32() {
    return get_jsRuntime().r35();
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_12 = this;
    this.s35_1 = Companion_getInstance_0().ew('JsRuntime');
  }
}
class JsRuntime {
  constructor() {
    Companion_getInstance_15();
    this.m35_1 = 'unknown';
    this.n35_1 = get_isDenoJs() ? 'deno.js' : get_isWeb() ? 'web.js' : get_isNodeJs() ? 'node.js' : get_isWorker() ? 'worker.js' : get_isShell() ? 'shell.js' : 'js';
  }
  o35(path) {
    throw NotImplementedError.md();
  }
  r35() {
    throw NotImplementedError.md();
  }
}
class JsRuntimeBrowser extends JsRuntime {
  constructor() {
    Companion_getInstance_16();
    super();
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    tmp.v35_1 = navigator.platform;
    var tmp_0 = this;
    tmp_0.w35_1 = lazy(JsRuntimeBrowser$href$delegate$lambda);
    var tmp_1 = this;
    tmp_1.x35_1 = lazy(JsRuntimeBrowser$baseUrl$delegate$lambda(this));
  }
  y35() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w35_1;
    href$factory();
    return this_0.p1();
  }
  z35() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x35_1;
    baseUrl$factory();
    return this_0.p1();
  }
  a36() {
    return this.z35();
  }
  o35(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.io.file.std.withCatalogJail' call
    var this_0 = UrlVfs_2(this.a36()).yh(path);
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.withCatalogJail.<anonymous>' call
    var this_1 = (new CatalogVfs(this_0.r23())).f23().f23();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.JsRuntimeBrowser.openVfs.<anonymous>' call
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_15().s35_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_2.h2t(level)) {
      // Inline function 'korlibs.io.runtime.JsRuntimeBrowser.openVfs.<anonymous>.<anonymous>' call
      var tmp$ret$3 = 'BROWSER openVfs: currentDir=' + this.a36() + ', path=' + path + ', urlVfs=' + this_1.toString();
      this_2.i2t(level, tmp$ret$3);
      tmp = Unit_instance;
    }
    return this_1;
  }
  r35() {
    return Companion_getInstance_11();
  }
}
class Companion_10 extends JsRuntimeBrowser {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class JsRuntimeDeno extends JsRuntimeBrowser {
  constructor() {
    Companion_getInstance_17();
    super();
  }
  a36() {
    try {
      var str = (new URL('.', Deno.mainModule)).pathname;
      var tmp;
      if (Companion_getInstance().rt()) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp = str.substring(1);
      } else {
        tmp = str;
      }
      return tmp;
    } catch ($p) {
      var e = $p;
      return '.';
    }
  }
  o35(path) {
    return (new DenoLocalVfs()).yh(path === '.' ? this.a36() : path);
  }
}
class Companion_11 extends JsRuntimeDeno {
  constructor() {
    Companion_instance_14 = null;
    super();
    Companion_instance_14 = this;
  }
}
class DenoLocalVfs extends LocalVfs {
  b23(path, mode, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_open__qjxcea_1.bind(VOID, this, path, mode), $completion);
  }
  d23(path, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_stat__qhnowc_1.bind(VOID, this, path), $completion);
  }
}
class DenoAsyncStreamBase extends AsyncStreamBase {
  static i36(file) {
    var $this = this.u1r();
    $this.g36_1 = file;
    $this.h36_1 = false;
    return $this;
  }
  n1r(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  v1r(position, buffer, offset, len, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_write__x1694l_0.bind(VOID, this, position, buffer, offset, len), $completion);
  }
  f1r($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getLength__lvva94_0.bind(VOID, this), $completion);
  }
  g1p($completion) {
    if (this.h36_1)
      return Unit_instance;
    this.g36_1.close();
    this.h36_1 = true;
  }
}
class workerImpl$o$insideWorker$lambda$lambda$slambda {
  constructor($workerTask, $id) {
    this.k36_1 = $workerTask;
    this.l36_1 = $id;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
  }
}
class workerImpl$1 extends _WorkerImpl {
  constructor() {
    super();
    this.m36_1 = 0;
  }
  n36() {
    return !(get_workerUrl() == null);
  }
  h35() {
    var tmp;
    if (get_isDenoJs()) {
      tmp = Deno.mainModule;
    } else {
      var tmp5_safe_receiver = lastOrNull(Companion_instance_15.q36().p36_1);
      tmp = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.s36_1;
    }
    set_workerUrl(tmp);
    if (get_workerUrl() == null) {
      println('workerUrl = null, STACKTRACE:' + stackTraceToString(Exception.qd()));
    }
    if (get_isWorker_0() && this.n36()) {
      // Inline function 'kotlin.js.asDynamic' call
      get_jsGlobalThis().onmessage = workerImpl$o$insideWorker$lambda;
    }
    return get_isWorker_0();
  }
}
class Entry {
  constructor(method, file, line, column) {
    column = column === VOID ? -1 : column;
    this.r36_1 = method;
    this.s36_1 = file;
    this.t36_1 = line;
    this.u36_1 = column;
  }
  toString() {
    return 'Entry(method=' + this.r36_1 + ', file=' + this.s36_1 + ', line=' + this.t36_1 + ', column=' + this.u36_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.r36_1);
    result = imul(result, 31) + getStringHashCode(this.s36_1) | 0;
    result = imul(result, 31) + this.t36_1 | 0;
    result = imul(result, 31) + this.u36_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.r36_1 === tmp0_other_with_cast.r36_1))
      return false;
    if (!(this.s36_1 === tmp0_other_with_cast.s36_1))
      return false;
    if (!(this.t36_1 === tmp0_other_with_cast.t36_1))
      return false;
    if (!(this.u36_1 === tmp0_other_with_cast.u36_1))
      return false;
    return true;
  }
}
class Companion_12 {
  v36(stack, message) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var entries = ArrayList.h1();
    // Inline function 'kotlin.collections.arrayListOf' call
    var messageLines = ArrayList.h1();
    var isChrome = false;
    var iterator = lines(stack).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var strLine = iterator.c1();
      // Inline function 'kotlin.text.trimEnd' call
      var strLine_0 = toString(trimEnd_0(isCharSequence(strLine) ? strLine : THROW_CCE()));
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(strLine_0) === 0) {
        tmp = !isChrome;
      } else {
        tmp = false;
      }
      if (tmp)
        continue $l$loop;
      if ((startsWith(strLine_0, 'Error: ') || strLine_0 === 'Error') && index_0 === 0) {
        isChrome = true;
        var tmp_0 = messageLines;
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = strLine_0.substring(7);
        tmp_0.h(tmp$ret$5);
      } else if (startsWith(strLine_0, '    at ')) {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$7 = strLine_0.substring(7);
        var part = trimEnd(tmp$ret$7, charArrayOf([_Char___init__impl__6a9atx(41)]));
        var column = substringAfterLast(part, _Char___init__impl__6a9atx(58));
        var part0 = substringBeforeLast(part, _Char___init__impl__6a9atx(58));
        var line = substringAfterLast(part0, _Char___init__impl__6a9atx(58));
        var part1 = substringBeforeLast(part0, _Char___init__impl__6a9atx(58));
        var tmp_1;
        if (contains_0(part1, _Char___init__impl__6a9atx(40))) {
          // Inline function 'kotlin.collections.map' call
          var this_0 = split(part1, ['(']);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
          var tmp0_iterator = this_0.a1();
          while (tmp0_iterator.b1()) {
            var item = tmp0_iterator.c1();
            // Inline function 'korlibs.js.Companion.parse.<anonymous>' call
            // Inline function 'kotlin.text.trim' call
            var tmp$ret$9 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
            destination.h(tmp$ret$9);
          }
          tmp_1 = destination;
        } else {
          // Inline function 'kotlin.text.trim' call
          var tmp$ret$12 = toString(trim(isCharSequence(part1) ? part1 : THROW_CCE()));
          tmp_1 = listOf(['', tmp$ret$12]);
        }
        var _destruct__k2r9zo = tmp_1;
        // Inline function 'kotlin.collections.component1' call
        var method = _destruct__k2r9zo.d1(0);
        // Inline function 'kotlin.collections.component2' call
        var file = _destruct__k2r9zo.d1(1);
        // Inline function 'kotlin.collections.plusAssign' call
        var tmp0_elvis_lhs = toIntOrNull(line);
        var tmp_2 = tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = toIntOrNull(column);
        var element = new Entry(method, file, tmp_2, tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs);
        entries.h(element);
      } else if (isChrome) {
        messageLines.h(strLine_0);
      } else {
        var cline = strLine_0;
        // Inline function 'kotlin.collections.arrayListOf' call
        var numParts = ArrayList.h1();
        var inductionVariable = 0;
        if (inductionVariable < 2)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp_3 = Regex.lh('^(.*):(\\d+)$');
            var tmp_4 = cline;
            cline = tmp_3.rh(tmp_4, JSStackTrace$Companion$parse$lambda(numParts));
          }
           while (inductionVariable < 2);
        var file_0 = substringAfterLast(cline, _Char___init__impl__6a9atx(64));
        var method_0 = substringBeforeLast(cline, _Char___init__impl__6a9atx(64));
        var tmp2_elvis_lhs = firstOrNull(numParts);
        var line_0 = tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
        var tmp_5;
        if (numParts.e1() >= 2) {
          var tmp3_elvis_lhs = lastOrNull(numParts);
          tmp_5 = tmp3_elvis_lhs == null ? -1 : tmp3_elvis_lhs;
        } else {
          tmp_5 = -1;
        }
        var column_0 = tmp_5;
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new Entry(method_0, file_0, line_0, column_0);
        entries.h(element_0);
      }
    }
    if (!isChrome) {
      messageLines = arrayListOf([message == null ? '' : message]);
    }
    if (entries.g1()) {
      entries.h(new Entry('<unknown>', '<unknown>', -1));
    }
    return new JSStackTrace(joinToString(messageLines, '\n'), entries);
  }
  w36(e) {
    return this.v36(stackTraceToString(e), e.message);
  }
  q36() {
    return this.w36(Exception.m5(''));
  }
}
class JSStackTrace {
  constructor(message, entries) {
    this.o36_1 = message;
    this.p36_1 = entries;
  }
  toString() {
    return 'JSStackTrace(message=' + this.o36_1 + ', entries=' + toString(this.p36_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.o36_1);
    result = imul(result, 31) + hashCode(this.p36_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof JSStackTrace))
      return false;
    var tmp0_other_with_cast = other instanceof JSStackTrace ? other : THROW_CCE();
    if (!(this.o36_1 === tmp0_other_with_cast.o36_1))
      return false;
    if (!equals(this.p36_1, tmp0_other_with_cast.p36_1))
      return false;
    return true;
  }
}
//endregion
function get_logger() {
  _init_properties_AsyncExt_kt__ahev1h();
  return logger;
}
var logger;
var DEFAULT_SUSPEND_TEST_TIMEOUT;
var DEFAULT_TEST_SYNC_IO;
function get_DEBUG_ASYNC_LAUNCH_ERRORS() {
  _init_properties_AsyncExt_kt__ahev1h();
  // Inline function 'kotlin.getValue' call
  var this_0 = DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
  DEBUG_ASYNC_LAUNCH_ERRORS$factory();
  return this_0.p1();
}
var DEBUG_ASYNC_LAUNCH_ERRORS$delegate;
function launchImmediately(context, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchImmediately_0(CoroutineScope(context), callback);
}
function launchImmediately_0(_this__u8e3s4, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  return _launch(_this__u8e3s4, CoroutineStart_UNDISPATCHED_getInstance(), callback);
}
function _launch(_this__u8e3s4, start, callback) {
  _init_properties_AsyncExt_kt__ahev1h();
  var tmp = _this__u8e3s4.q14();
  return launch(_this__u8e3s4, tmp, start, _launch$slambda_0(callback));
}
function launchUnscopedAndWait(_this__u8e3s4, block, $completion) {
  var deferred = CompletableDeferred();
  startCoroutine(block, new launchUnscopedAndWait$1(_this__u8e3s4, deferred));
  return deferred.h17($completion);
}
function launchUnscoped(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  return launchUnscoped_0(_this__u8e3s4.q14(), block);
}
function launchUnscoped_0(_this__u8e3s4, block) {
  _init_properties_AsyncExt_kt__ahev1h();
  startCoroutine(block, new launchUnscoped$1(_this__u8e3s4));
}
function DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda() {
  _init_properties_AsyncExt_kt__ahev1h();
  return Companion_instance_0.yh('DEBUG_ASYNC_LAUNCH_ERRORS') === 'true';
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  try {
    var tmp = $this.g2x_1($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        if (get_DEBUG_ASYNC_LAUNCH_ERRORS()) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_0 = get_logger();
          var level = Level_ERROR_getInstance();
          var tmp_0;
          if (this_0.h2t(level)) {
            // Inline function 'korlibs.io.async._launch.<anonymous>.<anonymous>' call
            var tmp$ret$0 = 'CoroutineScope._launch.catch:';
            this_0.i2t(level, tmp$ret$0);
            tmp_0 = Unit_instance;
          }
          printStackTrace(e_0);
        }
        throw e_0;
      } else {
        throw $p;
      }
    }
  }
  return Unit_instance;
}
function _launch$slambda_0($callback) {
  var i = new _launch$slambda($callback);
  var l = function ($this$launch, $completion) {
    return i.u1n($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function DEBUG_ASYNC_LAUNCH_ERRORS$factory() {
  return getPropertyCallableRef('DEBUG_ASYNC_LAUNCH_ERRORS', 0, KProperty0, function () {
    return get_DEBUG_ASYNC_LAUNCH_ERRORS();
  }, null);
}
var properties_initialized_AsyncExt_kt_7k2grr;
function _init_properties_AsyncExt_kt__ahev1h() {
  if (!properties_initialized_AsyncExt_kt_7k2grr) {
    properties_initialized_AsyncExt_kt_7k2grr = true;
    logger = Companion_getInstance_0().ew('AsyncExt');
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    DEFAULT_SUSPEND_TEST_TIMEOUT = toDuration(20, DurationUnit_SECONDS_getInstance());
    DEFAULT_TEST_SYNC_IO = false;
    DEBUG_ASYNC_LAUNCH_ERRORS$delegate = lazy(DEBUG_ASYNC_LAUNCH_ERRORS$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8_0($this, $this$withContext, $completion) {
  var tmp = protoOf(Proxy).b23.call($this.k2x_1, $this.l2x_1, $this.m2x_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.i1r_1;
}
function *_generator_write__x1694l($this, position, buffer, offset, len, $completion) {
  var tmp = $this.o2x_1.v1r(position, buffer, offset, len, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.comparisons.maxOf' call
  var a = $this.p2x_1._v;
  // Inline function 'kotlin.Long.plus' call
  var b = position.s3(toLong(len));
  var tmp$ret$1 = a.u1(b) >= 0 ? a : b;
  $this.p2x_1._v = tmp$ret$1;
  return Unit_instance;
}
function *_generator_open__qjxcea($this, path, mode, $completion) {
  var tmp = $this.w2x(path, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var fstat = tmp;
  if (!(fstat == null) && mode.equals(VfsOpenMode_READ_getInstance()) && fstat.a22_1.u1($this.s2x_1) <= 0) {
    var tmp_0 = $this.c23(path, get_LONG_ZERO_TO_MAX_RANGE(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return openAsync(tmp_0);
  }
  var tmp_1 = new VfsCachedStatContext(fstat);
  var tmp_2 = withContext(tmp_1, CatalogVfs$open$slambda_0($this, path, mode), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var base = tmp_2;
  var tmp_3;
  if ((fstat == null ? null : fstat.y21_1) === true) {
    tmp_3 = fstat.a22_1;
  } else {
    var tmp_4 = base.f1r($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    tmp_3 = tmp_4;
  }
  var maxSize = {_v: tmp_3};
  return buffered(toAsyncStream(CatalogVfs$open$2.x2x($this, base, maxSize)));
}
function *_generator_stat__qhnowc($this, path, $completion) {
  var tmp = $this.w2x(path, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? $this.j23(normalize(_PathInfo___init__impl__vpw96a(path)), VOID, true) : tmp0_elvis_lhs;
}
function *_generator_statOrNull__vj5496($this, path, $completion) {
  var normalizedPath = normalize(_PathInfo___init__impl__vpw96a(path));
  if (normalizedPath === '/' || normalizedPath === '') {
    return $this.h23('/', true, new Long(0, 0), VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  var baseName = get_baseName(_PathInfo___init__impl__vpw96a(normalizedPath));
  var tmp = $this.y2x(_PathInfo___get_fullPath__impl__21fx6x(get_parent(_PathInfo___init__impl__vpw96a(normalizedPath))), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = $this.u2x_1;
    var value = this_0.a3(path);
    var tmp_1;
    if (value == null) {
      // Inline function 'korlibs.io.file.std.CatalogVfs.statOrNull.<anonymous>' call
      var tmp_2 = $this.r2x_1.yh(path).z22($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      var answer = tmp_2;
      this_0.c3(path, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    return tmp_1;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var info = tmp_0;
  var tmp1_elvis_lhs = info.a3(baseName);
  return tmp1_elvis_lhs == null ? $this.j23(normalizedPath, VOID, true) : tmp1_elvis_lhs;
}
function *_generator_cachedListSimpleStatsOrNull__bbx84j($this, path, $completion) {
  var key = normalize(_PathInfo___init__impl__vpw96a(path));
  var tmp$ret$2;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.v2x_1;
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var res = this_0.get(key);
    if (!(res == null)) {
      tmp$ret$2 = res;
      break $l$block;
    }
    // Inline function 'korlibs.io.file.std.CatalogVfs.cachedListSimpleStatsOrNull.<anonymous>' call
    var tmp = $this.z2x(key, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var out = tmp;
    // Inline function 'korlibs.datastructure.set' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, out);
    tmp$ret$2 = out;
  }
  return tmp$ret$2;
}
function *_generator_listSimpleStatsOrNull__lelcpx($this, path, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.r2x_1.yh(path).yh('$catalog.json').q23(VOID, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      if (!(e instanceof FileNotFoundException)) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_0 = $this.t2x_1;
        var level = Level_ERROR_getInstance();
        var tmp_2;
        if (this_0.h2t(level)) {
          // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
          this_0.i2t(level, e);
          tmp_2 = Unit_instance;
        }
      }
      return null;
    } else {
      throw $p;
    }
  }
  var catalogJsonString = tmp;
  var data = get_dyn(Companion_getInstance_1().wy(catalogJsonString));
  var tmp24_subject = _Dyn___get_value__impl__bemnlg(data);
  if (!(tmp24_subject == null) ? isInterface(tmp24_subject, KtList) : false) {
    // Inline function 'kotlin.collections.associateBy' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = _Dyn___get_list__impl__qpwjp(data);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
      var it = item.x2w_1;
      var localName = get_baseName(_PathInfo___init__impl__vpw96a(_Dyn___get_str__impl__dup4cs(Dyn__get_impl_6l2p80_0(it, 'name'))));
      var tmp$ret$2 = $this.h23(path + '/' + localName, _Dyn___get_bool__impl__nv3iun(Dyn__get_impl_6l2p80_0(it, 'isDirectory')), _Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'size')), VOID, VOID, VOID, VOID, VOID, Companion_getInstance_2().k1u(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'createTime'))), Companion_getInstance_2().k1u(_Dyn___get_long__impl__wdxl7n(Dyn__get_impl_6l2p80_0(it, 'modifiedTime'))), VOID, VOID, VOID, true);
      destination.h(tmp$ret$2);
    }
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.ac(capacity);
    var tmp0_iterator_0 = destination.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'korlibs.io.file.std.CatalogVfs.listSimpleStatsOrNull.<anonymous>' call
      var tmp$ret$5 = get_baseName_0(element);
      destination_0.c3(tmp$ret$5, element);
    }
    return destination_0;
  } else {
    var out = LinkedHashMap.zb();
    var _iterator__ex2g4s = _Dyn___get_keys__impl__o4xmor(data).a1();
    while (_iterator__ex2g4s.b1()) {
      var key = _iterator__ex2g4s.c1().x2w_1;
      var fileName = _Dyn___get_str__impl__dup4cs(key);
      var info = Dyn__get_impl_6l2p80(data, key);
      var tmp0_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 0));
      var size = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 1));
      var creationTime = tmp1_elvis_lhs == null ? new Long(0, 0) : tmp1_elvis_lhs;
      var tmp2_elvis_lhs = Dyn__toLongOrNull_impl_ws7y8j(Dyn__get_impl_6l2p80_0(info, 2));
      var modifiedTime = tmp2_elvis_lhs == null ? creationTime : tmp2_elvis_lhs;
      var isDirectory = endsWith(fileName, '/');
      var baseName = trimEnd(fileName, charArrayOf([_Char___init__impl__6a9atx(47)]));
      // Inline function 'kotlin.collections.set' call
      var value = $this.h23(path + '/' + baseName, isDirectory, size, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_2().k1u(creationTime), Companion_getInstance_2().k1u(modifiedTime), VOID, VOID, VOID, true);
      out.c3(baseName, value);
    }
    return out;
  }
}
function CatalogVfs$open$slambda_0(this$0, $path, $mode) {
  var i = new CatalogVfs$open$slambda(this$0, $path, $mode);
  var l = function ($this$withContext, $completion) {
    return i.u1n($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var resourcesVfsDebug;
function get_resourcesVfs() {
  return get_standardVfs().a2y();
}
function get_localCurrentDirVfs() {
  return get_applicationVfs();
}
function *_generator_close__nh2uv0($this, $completion) {
  if ($this.c2y_1) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = $this.d2y_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.io.file.std.MountableVfs.close.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp = this_0.d1(_unary__edvuaz).cl_1.h21_1.g1p($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
  }
  return Unit_instance;
}
function unmountInternal($this, folder) {
  removeAll($this.d2y_1, MountableVfs$unmountInternal$lambda(folder));
}
function resort($this) {
  // Inline function 'kotlin.collections.sortByDescending' call
  var this_0 = $this.d2y_1;
  if (this_0.e1() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = MountableVfs$resort$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    sortWith(this_0, tmp$ret$0);
  }
}
function MountableVfs$unmountInternal$lambda($folder) {
  return function (it) {
    return it.bl_1 === normalize(get_pathInfo($folder));
  };
}
function MountableVfs$resort$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
  var tmp = b.bl_1.length;
  // Inline function 'korlibs.io.file.std.MountableVfs.resort.<anonymous>' call
  var tmp$ret$1 = a.bl_1.length;
  return compareValues(tmp, tmp$ret$1);
}
function UrlVfs_0(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_1(url.t2y(VOID, VOID, VOID, VOID, VOID, '', null).u2y(), Unit_instance, client, failFromStatus).yh(url.m2y_1);
}
function *_generator_read__qih2oe($this, position, buffer, offset, len, $completion) {
  if (len === 0)
    return 0;
  // Inline function 'kotlin.Long.plus' call
  var tmp$ret$0 = position.s3(toLong(len));
  var tmp = _readRangeBase($this.v2y_1, $this.y2y_1, until(position, tmp$ret$0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var s = res.e2z_1;
  var coffset = offset;
  var pending = len;
  var totalRead = 0;
  $l$loop: while (pending > 0) {
    var tmp_0 = s.f1p(buffer, coffset, pending, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var read = tmp_0;
    if (read < 0 && totalRead === 0)
      return read;
    if (read <= 0)
      break $l$loop;
    pending = pending - read | 0;
    totalRead = totalRead + read | 0;
    coffset = coffset + read | 0;
  }
  return totalRead;
}
function *_generator_getLength__lvva94($this, $completion) {
  var tmp;
  var tmp_0 = $this.g1r($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = $this.z2y_1.a22_1;
  } else {
    unsupported();
  }
  return tmp;
}
function *_generator_open__qjxcea_0($this, path, mode, $completion) {
  try {
    var fullUrl = $this.a24(path);
    if (startsWith(fullUrl, 'file:')) {
      var tmp = $this.l2z_1.n2z(fullUrl, VOID, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      return openAsync(tmp);
    }
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp34_safe_receiver = $completion.kc().xc(Companion_instance_1);
    var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.r22_1;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = $this.d23(path, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var stat = tmp_0;
    var tmp_2 = stat.j22_1;
    var response = tmp_2 instanceof Response ? tmp_2 : null;
    if (!stat.y21_1) {
      throw FileNotFoundException.ju('Unexistant ' + fullUrl + ' : ' + toString_0(response));
    }
    return buffered(toAsyncStream(FinalUrlVfs$open$2.o2z($this, path, mode, fullUrl, stat)));
  } catch ($p) {
    if ($p instanceof RuntimeException) {
      var e = $p;
      var tmp1_elvis_lhs = e.message;
      throw FileNotFoundException.ju(tmp1_elvis_lhs == null ? 'error' : tmp1_elvis_lhs);
    } else {
      throw $p;
    }
  }
}
function *_generator__readRangeBase__z0wzdd($this, fullUrl, range, $completion) {
  // Inline function 'kotlin.also' call
  var tmp = $this.l2z_1.c30(Companion_getInstance_6().q2z_1, fullUrl, Headers.b30(range.equals(get_LONG_ZERO_TO_MAX_RANGE()) ? LinkedHashMap.zb() : linkedHashMapOf([to('range', 'bytes=' + range.d2().toString() + '-' + range.c2().toString())])), VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.file.std.FinalUrlVfs._readRangeBase.<anonymous>' call
  if ($this.y23_1) {
    if (this_0.a2z_1 === 404)
      throw FileNotFoundException.ju(fullUrl + ' not found');
    var tmp_0 = this_0.d30($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return this_0;
}
function _readRangeBase($this, fullUrl, range, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readRangeBase__z0wzdd.bind(VOID, $this, fullUrl, range), $completion);
}
function *_generator_readRange__lxd64t($this, path, range, $completion) {
  var tmp = _readRangeBase($this, $this.a24(path), range, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = readAll(tmp.e2z_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_stat__qhnowc_0($this, path, $completion) {
  var fullUrl = $this.a24(path);
  var tmp;
  if (startsWith(fullUrl, 'file:')) {
    var tmp_0;
    try {
      var tmp_1 = $this.l2z_1.n2z(fullUrl, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var size = toLong(tmp_1.length);
      tmp_0 = $this.h23(path, false, size, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_2 = $this.j23(path);
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  } else {
    var tmp_3 = $this.l2z_1.c30(Companion_getInstance_6().r2z_1, fullUrl, VOID, VOID, VOID, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var result = tmp_3;
    var tmp_4;
    if (result.f2z_1) {
      var tmp36_safe_receiver = result.c2z_1.yh(Companion_instance_5.e30_1);
      var tmp0_elvis_lhs = tmp36_safe_receiver == null ? null : toLongOrNull(tmp36_safe_receiver);
      tmp_4 = $this.h23(path, false, tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, result);
    } else {
      tmp_4 = $this.j23(path, result);
    }
    tmp = tmp_4;
  }
  return tmp;
}
function UrlVfs_1(url, dummy, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return new FinalUrlVfs(url, dummy, client, failFromStatus);
}
function UrlVfs_2(url, client, failFromStatus) {
  client = client === VOID ? createHttpClient() : client;
  failFromStatus = failFromStatus === VOID ? true : failFromStatus;
  return UrlVfs_0(Companion_getInstance_5().ew(url), client, failFromStatus);
}
function currentStackTrace(msg) {
  msg = msg === VOID ? 'printStackTrace' : msg;
  return stackTraceToString(Exception.m5(msg));
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion();
  return Companion_instance_2;
}
function URL$fullUrl$delegate$lambda(this$0) {
  return function () {
    return this$0.v30().toString();
  };
}
function URL$fullUrlWithoutScheme$delegate$lambda(this$0) {
  return function () {
    return this$0.v30(false).toString();
  };
}
function URL$pathWithQuery$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (!(this$0.n2y_1 == null)) {
      tmp = this$0.m2y_1 + '?' + this$0.n2y_1;
    } else {
      tmp = this$0.m2y_1;
    }
    return tmp;
  };
}
function normalizeUrl(_this__u8e3s4) {
  // Inline function 'kotlin.text.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.firstOrNull' call
    var inductionVariable = 0;
    while (inductionVariable < charSequenceLength(_this__u8e3s4)) {
      var element = charSequenceGet(_this__u8e3s4, inductionVariable);
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.io.net.normalizeUrl.<anonymous>' call
      if (element === _Char___init__impl__6a9atx(63) || element === _Char___init__impl__6a9atx(35)) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new Char(tmp_0)) == null) {
    tmp = _Char___init__impl__6a9atx(63);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var paramFlag = tmp;
  var pathParts = toMutableList(split_0(_this__u8e3s4, charArrayOf([paramFlag])));
  pathParts.i3(0, normalize(get_pathInfo(pathParts.d1(0)), false));
  return joinToString(pathParts, toString_1(paramFlag));
}
function fullUrl$factory() {
  return getPropertyCallableRef('fullUrl', 1, KProperty1, function (receiver) {
    return receiver.u2y();
  }, null);
}
var Methods_ALL_instance;
var Methods_OPTIONS_instance;
var Methods_GET_instance;
var Methods_HEAD_instance;
var Methods_POST_instance;
var Methods_PUT_instance;
var Methods_DELETE_instance;
var Methods_TRACE_instance;
var Methods_CONNECT_instance;
var Methods_PATCH_instance;
var Methods_entriesInitialized;
function Methods_initEntries() {
  if (Methods_entriesInitialized)
    return Unit_instance;
  Methods_entriesInitialized = true;
  Methods_ALL_instance = new Methods('ALL', 0);
  Methods_OPTIONS_instance = new Methods('OPTIONS', 1);
  Methods_GET_instance = new Methods('GET', 2);
  Methods_HEAD_instance = new Methods('HEAD', 3);
  Methods_POST_instance = new Methods('POST', 4);
  Methods_PUT_instance = new Methods('PUT', 5);
  Methods_DELETE_instance = new Methods('DELETE', 6);
  Methods_TRACE_instance = new Methods('TRACE', 7);
  Methods_CONNECT_instance = new Methods('CONNECT', 8);
  Methods_PATCH_instance = new Methods('PATCH', 9);
}
var Companion_instance_3;
function Companion_getInstance_6() {
  if (Companion_instance_3 === VOID)
    new Companion_0();
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_7() {
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_8() {
  return Companion_instance_5;
}
function Http$Headers$toListGrouped$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = a.bl_1.toLowerCase();
  // Inline function 'korlibs.io.net.http.Headers.toListGrouped.<anonymous>' call
  // Inline function 'kotlin.text.toLowerCase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = b.bl_1.toLowerCase();
  return compareValues(tmp, tmp$ret$5);
}
function Methods_OPTIONS_getInstance() {
  Methods_initEntries();
  return Methods_OPTIONS_instance;
}
function Methods_GET_getInstance() {
  Methods_initEntries();
  return Methods_GET_instance;
}
function Methods_HEAD_getInstance() {
  Methods_initEntries();
  return Methods_HEAD_instance;
}
function Methods_POST_getInstance() {
  Methods_initEntries();
  return Methods_POST_instance;
}
function Methods_PUT_getInstance() {
  Methods_initEntries();
  return Methods_PUT_instance;
}
function Methods_DELETE_getInstance() {
  Methods_initEntries();
  return Methods_DELETE_instance;
}
function Methods_TRACE_getInstance() {
  Methods_initEntries();
  return Methods_TRACE_instance;
}
function Methods_CONNECT_getInstance() {
  Methods_initEntries();
  return Methods_CONNECT_instance;
}
function Methods_PATCH_getInstance() {
  Methods_initEntries();
  return Methods_PATCH_instance;
}
function get__defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  // Inline function 'kotlin.getValue' call
  var this_0 = _defaultHttpFactory$delegate;
  _defaultHttpFactory$factory();
  return this_0.p1();
}
var _defaultHttpFactory$delegate;
function *_generator_invoke__zhh2q8_1($this, status, statusText, headers, rawContent, $completion) {
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  var tmp0_elvis_lhs = headers.yh('Transfer-Encoding');
  // Inline function 'kotlin.js.asDynamic' call
  var this_0 = (tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs).toLowerCase();
  var transferEncoding = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.lowercase' call
  var tmp1_elvis_lhs = headers.yh('Content-Encoding');
  // Inline function 'kotlin.js.asDynamic' call
  var this_1 = (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs).toLowerCase();
  var contentEncoding = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
  var tmp = withTransferEncoding(rawContent, transferEncoding, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = withContentEncoding(tmp, contentEncoding, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return new Response(status, statusText, headers, rawContent, tmp_0);
}
var Companion_instance_6;
function Companion_getInstance_9() {
  return Companion_instance_6;
}
function *_generator_readAllBytes__ja4yyw($this, $completion) {
  var tmp = readAll($this.e2z_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var allContent = tmp;
  return allContent;
}
function *_generator_readAllString__7ikxrc($this, charset, $completion) {
  var tmp = $this.t31($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  return toString_2(bytes, charset);
}
function *_generator_checkErrors__u7iznj($this, $completion) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.net.http.Response.checkErrors.<anonymous>' call
  if (!$this.f2z_1) {
    var tmp = $this.u31(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    throw HttpException.j31($this.a2z_1, tmp, $this.b2z_1);
  }
  return $this;
}
function HttpClient$Response$responseCharset$delegate$lambda() {
  return get_UTF8();
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_4();
  return Companion_instance_7;
}
function mergeUrls($this, base, append) {
  return Companion_getInstance_5().u30(base, append);
}
function *_generator_request__hjt9xh($this, method, url, headers, content, config, $completion) {
  var tmp;
  if (content == null) {
    tmp = null;
  } else {
    var tmp_0 = content.f1r($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  }
  var tmp0_elvis_lhs = tmp;
  var contentLength = tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs;
  var actualHeaders = headers;
  var tmp_1;
  if (!(content == null)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(headers, Collection)) {
        tmp_2 = headers.g1();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = headers.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.io.net.http.HttpClient.request.<anonymous>' call
        if (equals_0(element.bl_1, Companion_instance_5.e30_1, true)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_1 = !tmp$ret$0;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    actualHeaders = actualHeaders.q31([to(Companion_instance_5.e30_1, contentLength.toString())]);
  }
  if (config.i32_1) {
    actualHeaders = Companion_getInstance_11().r32(actualHeaders, null);
  }
  // Inline function 'kotlin.apply' call
  var tmp_3 = $this.s32(method, url, actualHeaders, content, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var this_0 = tmp_3;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.io.net.http.HttpClient.request.<anonymous>' call
  if (config.f32_1) {
    var tmp_4 = this_0.d30($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  var response = this_0;
  if (config.e32_1 && config.g32_1 >= 0) {
    var redirectLocation = response.c2z_1.yh('location');
    if (!(redirectLocation == null)) {
      var tmp_5 = $this.t32(method, mergeUrls($this, url, redirectLocation), headers.q31([to('Referer', url)]), content, config.k32(VOID, VOID, config.g32_1 - 1 | 0), $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      return tmp_5;
    }
  }
  return response;
}
function *_generator_requestAsBytes__v4smbm($this, method, url, headers, content, config, $completion) {
  var tmp = $this.t32(method, url, headers, content, config, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var res = tmp;
  var tmp_0 = res.t31($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return res.y31(tmp_0);
}
function *_generator_readBytes__epy2u7($this, url, config, $completion) {
  var tmp = $this.u32(Companion_getInstance_6().q2z_1, url, VOID, VOID, config.k32(VOID, true), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.c32_1;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_5();
  return Companion_instance_8;
}
function createHttpClient() {
  _init_properties_HttpClient_kt__huy6s3();
  return get_defaultHttpFactory().x32();
}
var HttpStatusMessage_instance;
function HttpStatusMessage_getInstance() {
  if (HttpStatusMessage_instance === VOID)
    new HttpStatusMessage();
  return HttpStatusMessage_instance;
}
function *_generator_withContentEncoding__x3c14e(_this__u8e3s4, contentEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (contentEncoding) {
    case '':
    case 'plain':
      tmp = input;
      break;
    case 'gzip':
      var tmp_0 = uncompressed(input, Companion_getInstance_3(), VOID, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
      break;
    case 'deflate':
      var tmp_1 = uncompressed(input, get_Deflate(), VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = tmp_1;
      break;
    default:
      var message = "Unsupported Content-Encoding '" + contentEncoding + "'";
      throw IllegalStateException.t4(toString(message));
  }
  return tmp;
}
function withContentEncoding(_this__u8e3s4, contentEncoding, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withContentEncoding__x3c14e.bind(VOID, _this__u8e3s4, contentEncoding), $completion);
}
function *_generator_withTransferEncoding__5yv4cc(_this__u8e3s4, transferEncoding, $completion) {
  var input = _this__u8e3s4;
  var tmp;
  switch (transferEncoding) {
    case '':
    case 'identity':
      tmp = input;
      break;
    case 'chunked':
      var tmp_0 = asyncStreamWriter(VOID, 'chunked', VOID, withTransferEncoding$slambda_0(input), $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
      break;
    default:
      var message = "Unsupported Transfer-Encoding '" + transferEncoding + "'";
      throw IllegalStateException.t4(toString(message));
  }
  return tmp;
}
function withTransferEncoding(_this__u8e3s4, transferEncoding, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_withTransferEncoding__5yv4cc.bind(VOID, _this__u8e3s4, transferEncoding), $completion);
}
function createHttpClientFromFetch(fetch) {
  fetch = fetch === VOID ? Companion_getInstance_4() : fetch;
  _init_properties_HttpClient_kt__huy6s3();
  return new createHttpClientFromFetch$1(fetch);
}
function get_defaultHttpFactory() {
  _init_properties_HttpClient_kt__huy6s3();
  return get__defaultHttpFactory();
}
function createHttpClientFromFetch$accessor$8g8dwi(fetch) {
  fetch = fetch === VOID ? Companion_getInstance_4() : fetch;
  _init_properties_HttpClient_kt__huy6s3();
  return createHttpClientFromFetch(fetch);
}
function _defaultHttpFactory$delegate$lambda() {
  _init_properties_HttpClient_kt__huy6s3();
  return new ProxiedHttpFactory(get_httpFactory());
}
function *_generator_invoke__zhh2q8_2($this, out, $completion) {
  do {
    // Inline function 'kotlin.text.trim' call
    var tmp = readLine($this.a33_1, VOID, VOID, VOID, 16, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var this_0 = tmp;
    var nbytesString = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    var tmp0_elvis_lhs = toIntOrNull_0(nbytesString, 16);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't convert '" + nbytesString + "' into int for chunked encoding";
      throw IllegalStateException.t4(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var nbytes = tmp_0;
    if (nbytes > 0) {
      var tmp_1 = readBytesExact($this.a33_1, nbytes, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var bytes = tmp_1;
      var tmp_2 = out.e1p(bytes, VOID, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      var tmp_3 = readLine($this.a33_1, VOID, VOID, VOID, 2, VOID, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
    }
  }
   while (nbytes > 0);
  return Unit_instance;
}
function withTransferEncoding$slambda_0($input) {
  var i = new withTransferEncoding$slambda($input);
  var l = function (out, $completion) {
    return i.l20(out, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_requestInternal__facax4($this, method, url, headers, content, $completion) {
  var url_0 = Companion_getInstance_5().ew(url);
  var tmp = method.m3();
  var tmp0_elvis_lhs = url_0.l2y_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var message = 'Missing host';
    throw IllegalStateException.t4(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_1 = $this.c33_1.k2t(tmp, tmp_0, url_0.y30(), url_0.m2y_1, url_0.w30(), toList_0(headers), content, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = Companion_instance_6.s31(result.l2t_1, result.m2t_1, Headers.m31(result.n2t_1), result.o2t_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return tmp_2;
}
function _defaultHttpFactory$factory() {
  return getPropertyCallableRef('_defaultHttpFactory', 0, KProperty0, function () {
    return get__defaultHttpFactory();
  }, null);
}
function responseCharset$factory() {
  return getPropertyCallableRef('responseCharset', 1, KProperty1, function (receiver) {
    return receiver.w31();
  }, null);
}
var properties_initialized_HttpClient_kt_t7kzvv;
function _init_properties_HttpClient_kt__huy6s3() {
  if (!properties_initialized_HttpClient_kt_t7kzvv) {
    properties_initialized_HttpClient_kt_t7kzvv = true;
    _defaultHttpFactory$delegate = lazy(_defaultHttpFactory$delegate$lambda);
  }
}
var EmptyLineOnce_instance;
function EmptyLineOnce_getInstance() {
  return EmptyLineOnce_instance;
}
var Indent_instance;
function Indent_getInstance() {
  return Indent_instance;
}
var Unindent_instance;
function Unindent_getInstance() {
  return Unindent_instance;
}
var INDENTS_instance;
function INDENTS_getInstance_0() {
  return INDENTS_instance;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  if (Companion_instance_9 === VOID)
    new Companion_6();
  return Companion_instance_9;
}
function get_LONG_ZERO_TO_MAX_RANGE() {
  _init_properties_RangeExt_kt__vz0y4k();
  return LONG_ZERO_TO_MAX_RANGE;
}
var LONG_ZERO_TO_MAX_RANGE;
var properties_initialized_RangeExt_kt_dqkq5i;
function _init_properties_RangeExt_kt__vz0y4k() {
  if (!properties_initialized_RangeExt_kt_dqkq5i) {
    properties_initialized_RangeExt_kt_dqkq5i = true;
    LONG_ZERO_TO_MAX_RANGE = (new Long(0, 0)).x1(new Long(-1, 2147483647));
  }
}
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function posSkip($this, count) {
  var out = $this.n30_1;
  $this.n30_1 = $this.n30_1 + count | 0;
  return out;
}
function substr($this, pos, length) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = $this.l30_1;
  // Inline function 'kotlin.math.min' call
  var b = $this.p30_1;
  var startIndex = Math.min(pos, b);
  // Inline function 'kotlin.math.min' call
  var a = pos + length | 0;
  var b_0 = $this.p30_1;
  var endIndex = Math.min(a, b_0);
  // Inline function 'kotlin.js.asDynamic' call
  return this_0.substring(startIndex, endIndex);
}
function get_DEBUG_WORKER() {
  _init_properties_Worker_kt__eidt7m();
  return DEBUG_WORKER;
}
var DEBUG_WORKER;
function DemoWorkerTask$execute$slambda_0() {
  var i = new DemoWorkerTask$execute$slambda();
  var l = function (params, $completion) {
    return i.l34(params, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'kotlin.runCatching' call
  var this_0 = $this.e35_1;
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    // Inline function 'korlibs.io.worker.WorkerTask.runSuspend.<anonymous>.<anonymous>' call
    var tmp_0 = $this.f35_1(this_0.z34(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var value = tmp_0;
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  var tmp$ret$3 = tmp;
  completeWith($this.d35_1, tmp$ret$3);
  return Unit_instance;
}
function WorkerTask$runSuspend$slambda_0($deferred, this$0, $block) {
  var i = new WorkerTask$runSuspend$slambda($deferred, this$0, $block);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  return Companion_instance_11;
}
var properties_initialized_Worker_kt_gr88g0;
function _init_properties_Worker_kt__eidt7m() {
  if (!properties_initialized_Worker_kt_gr88g0) {
    properties_initialized_Worker_kt_gr88g0 = true;
    DEBUG_WORKER = Companion_instance_0.yh('DEBUG_WORKER') === 'true';
  }
}
function *_generator_delay__nu7n9t(time, $completion) {
  var tmp = delay(numberToLong(_FastDuration___get_milliseconds__impl__ffr17u(time)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function delay_0(time, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_delay__nu7n9t.bind(VOID, time), $completion);
}
function get_jsGlobalDynamic() {
  _init_properties_KorioNativeJs_kt__151su();
  return jsGlobalDynamic;
}
var jsGlobalDynamic;
var jsGlobal;
function get_isDenoJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isDenoJs$delegate;
  isDenoJs$factory();
  return this_0.p1();
}
var isDenoJs$delegate;
function get_isWeb() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWeb$delegate;
  isWeb$factory();
  return this_0.p1();
}
var isWeb$delegate;
function get_isWorker() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isWorker$delegate;
  isWorker$factory();
  return this_0.p1();
}
var isWorker$delegate;
function get_isNodeJs() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.getValue' call
  var this_0 = isNodeJs$delegate;
  isNodeJs$factory();
  return this_0.p1();
}
var isNodeJs$delegate;
function set__jsRuntime(_set____db54di) {
  _init_properties_KorioNativeJs_kt__151su();
  _jsRuntime = _set____db54di;
}
function get__jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  return _jsRuntime;
}
var _jsRuntime;
function get_jsRuntime() {
  _init_properties_KorioNativeJs_kt__151su();
  var tmp0_elvis_lhs = get__jsRuntime();
  set__jsRuntime(tmp0_elvis_lhs == null ? get_isDenoJs() ? Companion_getInstance_17() : Companion_getInstance_16() : tmp0_elvis_lhs);
  return ensureNotNull(get__jsRuntime());
}
function get_isShell() {
  _init_properties_KorioNativeJs_kt__151su();
  return !get_isWeb() && !get_isNodeJs() && !get_isWorker();
}
function isDenoJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof Deno === 'object' && Deno.statSync !== undefined;
}
function isWeb$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof window === 'object';
}
function isWorker$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof importScripts === 'function';
}
function isNodeJs$delegate$lambda() {
  _init_properties_KorioNativeJs_kt__151su();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof process !== 'undefined' && process.release && process.release.name.search(/node|io.js/) !== -1;
}
function isDenoJs$factory() {
  return getPropertyCallableRef('isDenoJs', 0, KProperty0, function () {
    return get_isDenoJs();
  }, null);
}
function isWeb$factory() {
  return getPropertyCallableRef('isWeb', 0, KProperty0, function () {
    return get_isWeb();
  }, null);
}
function isWorker$factory() {
  return getPropertyCallableRef('isWorker', 0, KProperty0, function () {
    return get_isWorker();
  }, null);
}
function isNodeJs$factory() {
  return getPropertyCallableRef('isNodeJs', 0, KProperty0, function () {
    return get_isNodeJs();
  }, null);
}
var properties_initialized_KorioNativeJs_kt_y4p8os;
function _init_properties_KorioNativeJs_kt__151su() {
  if (!properties_initialized_KorioNativeJs_kt_y4p8os) {
    properties_initialized_KorioNativeJs_kt_y4p8os = true;
    jsGlobalDynamic = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
    jsGlobal = get_jsGlobalDynamic();
    isDenoJs$delegate = lazy(isDenoJs$delegate$lambda);
    isWeb$delegate = lazy(isWeb$delegate$lambda);
    isWorker$delegate = lazy(isWorker$delegate$lambda);
    isNodeJs$delegate = lazy(isNodeJs$delegate$lambda);
    _jsRuntime = null;
  }
}
function toVfs(_this__u8e3s4) {
  var file = _this__u8e3s4;
  return (new toVfs$1(file)).yh(file.name);
}
function openAsync_0(_this__u8e3s4) {
  return buffered(toAsyncStream(BlobAsyncBaseStream.j35(_this__u8e3s4)), 65536, 16);
}
function BlobAsyncBaseStream$read$lambda($reader, $len, $buffer, $offset, $deferred) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    var ab = $reader.result;
    // Inline function 'kotlin.math.min' call
    var a = ab.byteLength;
    var b = $len;
    var minLen = Math.min(a, b);
    arraycopy(toByteArray(new Int8Array(ab)), 0, $buffer, $offset, minLen);
    return $deferred.y1a(minLen);
  };
}
function BlobAsyncBaseStream$read$lambda_0($deferred, $reader) {
  return function (it) {
    return $deferred.x1a(newThrowable('' + $reader.error));
  };
}
function get_standardVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return standardVfs;
}
var standardVfs;
function get_applicationVfs() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  // Inline function 'kotlin.getValue' call
  var this_0 = applicationVfs$delegate;
  applicationVfs$factory();
  return this_0.p1();
}
var applicationVfs$delegate;
var applicationDataVfsOrNull;
var cacheVfsOrNull;
var externalStorageVfs$delegate;
var userHomeVfs$delegate;
var tempVfsOrNull;
function localVfs(path, async) {
  async = async === VOID ? true : async;
  _init_properties_LocalVfsJs_kt__kywvdr();
  return get_jsRuntime().o35(path);
}
function standardVfs$o$resourcesVfs$delegate$lambda() {
  return get_applicationVfs().r23();
}
function standardVfs$o$rootLocalVfs$delegate$lambda() {
  return localVfs('.');
}
function applicationVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function externalStorageVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function userHomeVfs$delegate$lambda() {
  _init_properties_LocalVfsJs_kt__kywvdr();
  return localVfs('.');
}
function applicationVfs$factory() {
  return getPropertyCallableRef('applicationVfs', 0, KProperty0, function () {
    return get_applicationVfs();
  }, null);
}
function resourcesVfs$factory() {
  return getPropertyCallableRef('resourcesVfs', 1, KProperty1, function (receiver) {
    return receiver.a2y();
  }, null);
}
var properties_initialized_LocalVfsJs_kt_51m659;
function _init_properties_LocalVfsJs_kt__kywvdr() {
  if (!properties_initialized_LocalVfsJs_kt_51m659) {
    properties_initialized_LocalVfsJs_kt_51m659 = true;
    standardVfs = new standardVfs$1();
    applicationVfs$delegate = lazy(applicationVfs$delegate$lambda);
    applicationDataVfsOrNull = null;
    cacheVfsOrNull = null;
    externalStorageVfs$delegate = lazy(externalStorageVfs$delegate$lambda);
    userHomeVfs$delegate = lazy(userHomeVfs$delegate$lambda);
    tempVfsOrNull = null;
  }
}
var StandardPaths_instance;
function StandardPaths_getInstance() {
  return StandardPaths_instance;
}
function get_httpFactory() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  // Inline function 'kotlin.getValue' call
  var this_0 = httpFactory$delegate;
  httpFactory$factory();
  return this_0.p1();
}
var httpFactory$delegate;
function httpFactory$delegate$lambda() {
  _init_properties_HttpFactoryJs_kt__a3ro2v();
  return new httpFactory$2$1();
}
function httpFactory$factory() {
  return getPropertyCallableRef('httpFactory', 0, KProperty0, function () {
    return get_httpFactory();
  }, null);
}
var properties_initialized_HttpFactoryJs_kt_on1x9h;
function _init_properties_HttpFactoryJs_kt__a3ro2v() {
  if (!properties_initialized_HttpFactoryJs_kt_on1x9h) {
    properties_initialized_HttpFactoryJs_kt_on1x9h = true;
    httpFactory$delegate = lazy(httpFactory$delegate$lambda);
  }
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_9();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_10();
  return Companion_instance_13;
}
function JsRuntimeBrowser$href$delegate$lambda() {
  var tmp1_safe_receiver = document.location;
  var tmp0_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.href;
  return tmp0_elvis_lhs == null ? '.' : tmp0_elvis_lhs;
}
function JsRuntimeBrowser$baseUrl$delegate$lambda(this$0) {
  return function () {
    return endsWith(this$0.y35(), '/') ? this$0.y35() : substringBeforeLast(this$0.y35(), _Char___init__impl__6a9atx(47));
  };
}
function href$factory() {
  return getPropertyCallableRef('href', 1, KProperty1, function (receiver) {
    return receiver.y35();
  }, null);
}
function baseUrl$factory() {
  return getPropertyCallableRef('baseUrl', 1, KProperty1, function (receiver) {
    return receiver.z35();
  }, null);
}
var Companion_instance_14;
function Companion_getInstance_17() {
  if (Companion_instance_14 === VOID)
    new Companion_11();
  return Companion_instance_14;
}
function getFullPath($this, path) {
  return normalize(get_pathInfo(path));
}
function *_generator_open__qjxcea_1($this, path, mode, $completion) {
  var options = jsObject([to('read', mode.u21_1), to('write', mode.r21_1), to('append', mode.v21_1), to('truncate', mode.t21_1), to('create', mode.r21_1), to('mode', toInt('666', 8))]);
  var fullPath = getFullPath($this, path);
  try {
    var tmp = await_0(Deno.open(fullPath, options), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var file = tmp;
    return toAsyncStream(DenoAsyncStreamBase.i36(file));
  } catch ($p) {
    var e = $p;
    if (e && e.code == 'ENOENT')
      throw FileNotFoundException.ju("Can't open file " + fullPath);
    throw e;
  }
}
function *_generator_stat__qhnowc_1($this, path, $completion) {
  var tmp;
  try {
    // Inline function 'kotlin.let' call
    var tmp_0 = await_0(Deno.stat(getFullPath($this, path)), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.runtime.DenoLocalVfs.stat.<anonymous>' call
    var it = tmp_0;
    var tmp_1 = it.isDirectory;
    var tmp_2 = numberToLong(it.size);
    var tmp_3 = numberToLong(it.dev);
    var tmp2_safe_receiver = it.ino;
    var tmp0_elvis_lhs = tmp2_safe_receiver == null ? null : numberToLong(tmp2_safe_receiver);
    var tmp_4 = tmp0_elvis_lhs == null ? new Long(-1, -1) : tmp0_elvis_lhs;
    var tmp3_safe_receiver = it.mode;
    var tmp1_elvis_lhs = tmp3_safe_receiver == null ? null : numberToInt(tmp3_safe_receiver);
    tmp = $this.h23(path, tmp_1, tmp_2, tmp_3, tmp_4, tmp1_elvis_lhs == null ? toInt('777', 8) : tmp1_elvis_lhs);
  } catch ($p) {
    var tmp_5;
    if ($p instanceof Error) {
      var e = $p;
      tmp_5 = $this.j23(path);
    } else {
      throw $p;
    }
    tmp = tmp_5;
  }
  return tmp;
}
function *_generator_read__qih2oe_0($this, position, buffer, offset, len, $completion) {
  var tmp = await_0($this.g36_1.seek(position.g4(), Deno.SeekMode.Start), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = await_0($this.g36_1.read(new Uint8Array(buffer.buffer, offset, len)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var read = tmp_0;
  var tmp0_elvis_lhs = read == null ? null : numberToInt(read);
  return tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs;
}
function *_generator_write__x1694l_0($this, position, buffer, offset, len, $completion) {
  var tmp = await_0($this.g36_1.seek(position.g4(), Deno.SeekMode.Start), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = await_0($this.g36_1.write(new Uint8Array(buffer.buffer, offset, len)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_getLength__lvva94_0($this, $completion) {
  var tmp = await_0($this.g36_1.stat(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return numberToLong(tmp.size);
}
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.asDynamic' call
  var tout = _this__u8e3s4;
  var tmp;
  if (!(tout == null) ? isByteArray(tout) : false) {
    // Inline function 'kotlin.js.unsafeCast' call
    tmp = tout;
  } else {
    var out = new Int8Array(_this__u8e3s4.length);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = _this__u8e3s4[n];
      }
       while (inductionVariable <= last);
    tmp = out;
  }
  return tmp;
}
function set_workerUrl(_set____db54di) {
  _init_properties_Worker_js_kt__6mcbpj();
  workerUrl = _set____db54di;
}
function get_workerUrl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerUrl;
}
var workerUrl;
function get_workerImpl() {
  _init_properties_Worker_js_kt__6mcbpj();
  return workerImpl;
}
var workerImpl;
function get_isWorker_0() {
  _init_properties_Worker_js_kt__6mcbpj();
  // Inline function 'kotlin.js.unsafeCast' call
  return typeof DedicatedWorkerGlobalScope === 'function';
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  try {
    $this.k36_1.r34();
    var result = $this.k36_1.v34_1;
    if (!(result == null) ? isInterface(result, Deferred) : false) {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$0 = get_jsGlobalThis();
      // Inline function 'kotlin.arrayOf' call
      var tmp = result.h17($completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$3 = [$this.l36_1, 'ok', tmp];
      tmp$ret$0.postMessage(tmp$ret$3);
    } else {
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = get_jsGlobalThis();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = [$this.l36_1, 'ok', result];
      tmp$ret$4.postMessage(tmp$ret$7);
    }
  } catch ($p) {
    var e = $p;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = get_jsGlobalThis();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$11 = [$this.l36_1, 'error', e.stack];
    tmp$ret$8.postMessage(tmp$ret$11);
  }
  return Unit_instance;
}
function workerImpl$o$insideWorker$lambda(evt) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var input = evt.data;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var id = input[0];
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp0_elvis_lhs = input[1];
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? get_workerUrl() : tmp0_elvis_lhs;
  var moduleUrl = tmp1_elvis_lhs == null ? '.' : tmp1_elvis_lhs;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var clazzName = input[2];
  var params = drop(input, 3);
  var tmp = import(moduleUrl);
  var tmp_0 = tmp instanceof Promise ? tmp : THROW_CCE();
  var imported = tmp_0.then(workerImpl$o$insideWorker$lambda$lambda(clazzName, params, id));
  return Unit_instance;
}
function workerImpl$o$insideWorker$lambda$lambda$slambda_0($workerTask, $id) {
  var i = new workerImpl$o$insideWorker$lambda$lambda$slambda($workerTask, $id);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function workerImpl$o$insideWorker$lambda$lambda($clazzName, $params, $id) {
  return function (imported) {
    // Inline function 'kotlin.js.asDynamic' call
    var taskClass = imported[$clazzName];
    // Inline function 'kotlin.js.unsafeCast' call
    var workerTask = jsNew(taskClass);
    workerTask.u34_1 = toList_0($params);
    var tmp = EmptyCoroutineContext_getInstance();
    return launchImmediately(tmp, workerImpl$o$insideWorker$lambda$lambda$slambda_0(workerTask, $id));
  };
}
var properties_initialized_Worker_js_kt_gnq77b;
function _init_properties_Worker_js_kt__6mcbpj() {
  if (!properties_initialized_Worker_js_kt_gnq77b) {
    properties_initialized_Worker_js_kt_gnq77b = true;
    var tmp0_elvis_lhs = globalThis.location;
    workerUrl = tmp0_elvis_lhs == null ? get_isDenoJs() ? Deno.mainModule : '.' : tmp0_elvis_lhs;
    workerImpl = new workerImpl$1();
  }
}
function JSStackTrace$Companion$parse$lambda($numParts) {
  return function (it) {
    var tmp0_elvis_lhs = toIntOrNull(it.pi().d1(2));
    $numParts.u6(0, tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs);
    return it.pi().d1(1);
  };
}
var Companion_instance_15;
function Companion_getInstance_18() {
  return Companion_instance_15;
}
//region block: post-declaration
initMetadataForLambda(_launch$slambda, VOID, VOID, [1]);
initMetadataForClass(launchUnscopedAndWait$1);
initMetadataForClass(launchUnscoped$1);
initMetadataForLambda(CatalogVfs$open$slambda, VOID, VOID, [1]);
initMetadataForClass(CatalogVfs$open$2, VOID, VOID, VOID, VOID, [4, 1, 0]);
initMetadataForClass(CatalogVfs, 'CatalogVfs', VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(StandardVfs, 'StandardVfs', StandardVfs);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(MountableVfs, 'MountableVfs', VOID, VOID, VOID, [0, 1, 4, 2, 3]);
initMetadataForInterface(StandardPathsBase, 'StandardPathsBase');
initMetadataForClass(FinalUrlVfs$open$2, VOID, VOID, VOID, VOID, [4, 0, 1]);
initMetadataForClass(FinalUrlVfs, 'FinalUrlVfs', VOID, VOID, VOID, [2, 1, 3, 0, 4]);
initMetadataForCompanion(Companion);
initMetadataForClass(URL_0, 'URL');
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForCompanion(Companion_2);
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Methods, 'Methods');
initMetadataForClass(HttpException, 'HttpException');
initMetadataForClass(Headers, 'Headers', VOID, VOID, [Iterable]);
initMetadataForCompanion(Companion_3, VOID, VOID, [4]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Response, 'Response', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(CompletedResponse, 'CompletedResponse');
initMetadataForClass(RequestConfig, 'RequestConfig', RequestConfig);
initMetadataForInterface(HttpClient, 'HttpClient', VOID, VOID, VOID, [4, 5, 2]);
protoOf(Companion_5).c30 = request$default;
protoOf(Companion_5).u32 = requestAsBytes$default;
protoOf(Companion_5).n2z = readBytes$default;
initMetadataForCompanion(Companion_5, VOID, [HttpClient], [4, 5, 2]);
initMetadataForObject(HttpStatusMessage, 'HttpStatusMessage');
initMetadataForClass(ProxiedHttpFactory, 'ProxiedHttpFactory');
initMetadataForLambda(withTransferEncoding$slambda, VOID, VOID, [1]);
protoOf(createHttpClientFromFetch$1).t32 = request;
protoOf(createHttpClientFromFetch$1).c30 = request$default;
protoOf(createHttpClientFromFetch$1).v32 = requestAsBytes;
protoOf(createHttpClientFromFetch$1).u32 = requestAsBytes$default;
protoOf(createHttpClientFromFetch$1).w32 = readBytes;
protoOf(createHttpClientFromFetch$1).n2z = readBytes$default;
initMetadataForClass(createHttpClientFromFetch$1, VOID, VOID, VOID, [HttpClient], [4, 5, 2]);
initMetadataForClass(Resources, 'Resources');
initMetadataForInterface(Text, 'Text');
initMetadataForClass(Marker, 'Marker');
initMetadataForClass(Line, 'Line', VOID, VOID, [Text]);
initMetadataForClass(LineDeferred, 'LineDeferred');
initMetadataForObject(EmptyLineOnce, 'EmptyLineOnce');
initMetadataForObject(Indent, 'Indent');
initMetadataForObject(Unindent, 'Unindent');
initMetadataForObject(INDENTS, 'INDENTS');
initMetadataForCompanion(Companion_6);
initMetadataForClass(IndenterEvaluator, 'IndenterEvaluator');
initMetadataForClass(Indenter, 'Indenter', Indenter);
initMetadataForClass(Once, 'Once', Once);
initMetadataForCompanion(Companion_7);
protoOf(BaseStrReader).ow = toStringContext;
initMetadataForClass(BaseStrReader, 'BaseStrReader', VOID, VOID, [SimpleStrReader]);
initMetadataForClass(StrReader, 'StrReader');
initMetadataForLambda(DemoWorkerTask$execute$slambda, VOID, VOID, [1]);
initMetadataForClass(WorkerTask, 'WorkerTask', WorkerTask);
initMetadataForClass(DemoWorkerTask, 'DemoWorkerTask', DemoWorkerTask);
initMetadataForLambda(WorkerTask$runSuspend$slambda, VOID, VOID, [0]);
initMetadataForClass(_WorkerImpl, '_WorkerImpl', _WorkerImpl, VOID, VOID, [4]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(BlobAsyncBaseStream, 'BlobAsyncBaseStream', VOID, VOID, VOID, [0, 4, 1]);
initMetadataForClass(toVfs$1, VOID, VOID, VOID, VOID, [2, 1, 0, 4, 3]);
initMetadataForClass(standardVfs$1);
protoOf(StandardPaths).g2y = appPreferencesFolder;
initMetadataForObject(StandardPaths, 'StandardPaths', VOID, VOID, [StandardPathsBase]);
initMetadataForClass(httpFactory$2$1);
initMetadataForCompanion(Companion_9);
initMetadataForClass(JsRuntime, 'JsRuntime', VOID, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeBrowser, 'JsRuntimeBrowser', JsRuntimeBrowser, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_10, VOID, VOID, [1, 4]);
initMetadataForClass(JsRuntimeDeno, 'JsRuntimeDeno', JsRuntimeDeno, VOID, VOID, [1, 4]);
initMetadataForCompanion(Companion_11, VOID, VOID, [1, 4]);
initMetadataForClass(DenoLocalVfs, 'DenoLocalVfs', DenoLocalVfs, VOID, VOID, [2, 1, 4, 0, 3]);
initMetadataForClass(DenoAsyncStreamBase, 'DenoAsyncStreamBase', VOID, VOID, VOID, [4, 1, 0]);
initMetadataForLambda(workerImpl$o$insideWorker$lambda$lambda$slambda, VOID, VOID, [0]);
initMetadataForClass(workerImpl$1, VOID, VOID, VOID, VOID, [4]);
initMetadataForClass(Entry, 'Entry');
initMetadataForCompanion(Companion_12);
initMetadataForClass(JSStackTrace, 'JSStackTrace');
//endregion
//region block: init
resourcesVfsDebug = false;
Companion_instance_4 = new Companion_1();
Companion_instance_5 = new Companion_2();
Companion_instance_6 = new Companion_3();
EmptyLineOnce_instance = new EmptyLineOnce();
Indent_instance = new Indent();
Unindent_instance = new Unindent();
INDENTS_instance = new INDENTS();
Companion_instance_10 = new Companion_7();
Companion_instance_11 = new Companion_8();
StandardPaths_instance = new StandardPaths();
Companion_instance_15 = new Companion_12();
//endregion
//region block: exports
export {
  DemoWorkerTask as DemoWorkerTask,
};
export {
  launchUnscopedAndWait as launchUnscopedAndWait1ibbocika451b,
  delay_0 as delay2vwv568c245r8,
  StandardPaths_instance as StandardPaths_instanceid246em8v040,
  Companion_getInstance_12 as Companion_getInstance2vt0vokm4ixbh,
  Companion_instance_11 as Companion_instance20wy3vp7551rj,
  launchImmediately as launchImmediatelylnv8lnistpdy,
  launchImmediately_0 as launchImmediately11za8mkid9pxu,
  launchUnscoped as launchUnscopedpyoa01nqmf1z,
  launchUnscoped_0 as launchUnscoped2lqe6wwpvfo83,
  MountableVfs as MountableVfs3mmbka3zq5l6i,
  get_localCurrentDirVfs as get_localCurrentDirVfs2lka1gsv26an5,
  get_resourcesVfs as get_resourcesVfs3qrvup7jpy9uc,
  toVfs as toVfsr7ir4p66g1my,
  Resources as Resources1ysf2j4wd5yk7,
  Indenter as Indenterdf10c5coibyi,
  Once as Once1q3lxlgflq3fq,
  get_DEBUG_WORKER as get_DEBUG_WORKER2r7zp31jch3ip,
  get_workerImpl as get_workerImpl14jb6v5ie8q11,
};
//endregion
